<template>
  <div :class=" isStyleApplied?'flightPlayback_eyeshield':'flightPlayback'">
    <div   style="width: 100%; height: 100%;display:flex">
      <div id="svg-container"></div> <!-- 用于插入 SVG 的容器 -->
      <div v-show="!show2DMap" style="width: 100%;height: 100%">
        <ThreedPlayback width="100%" height="100%;"></ThreedPlayback>
      </div>
      <div
        v-show="show2DMap"
        ref="mapRef"
        id="map-container"
        style="width: 100%; height: 100%"
      ></div>
      <div style="display: block;">
        <div class="openLeft" v-show="!openLeft" @click="openLeft = true">

          <img :src="require(`../../assets/img/${isStyleApplied?'2dmap_eyes':'2dmap'}/pop_close_open.png`)" alt="" />
        </div>
        <div class="closeLeft" v-show="openLeft" @click="openLeft = false">
          <img :src="require(`../../assets/img/${isStyleApplied?'2dmap_eyes':'2dmap'}/pop_close_open.png`)" alt="" />
        </div>
        <div class="closeMapChange" title="切换地图"  @click="changeMap">
          <img :src="show2DMap?require(`../../assets/img/${isStyleApplied?'2dmap_eyes':'2dmap'}/changeMap2D.png`):require(`../../assets/img/${isStyleApplied?'2dmap_eyes':'2dmap'}/changeMap3D.png`)" alt=""/>
        </div>
        <!--        <div class="openMapChange" title="切换地图" v-show="!openLeft" @click="changeMap">-->
        <!--          <img src="../../assets/img/2dmap/changeMap.png" alt=""/>-->
        <!--        </div>-->
        <div class="leftContent" v-show="openLeft">
          <div class="titleWrap">
            <div class="titleText">筛选飞机</div>
            <!-- <el-button class="planeSearchBtn" @click="filterPlane" icon="el-icon-search">搜索</el-button> -->
          </div>
          <div class="searchWrap">
            <div class="searchContainer">
              <el-date-picker
                v-model="startTime"
                type="datetime"
                :picker-options="pickerOptions"
                @change="handleStartTimeChange"
                placeholder="选择开始时间">
              </el-date-picker>
            </div>
            <div class="searchContainer">
              <el-date-picker
                v-model="endTime"
                type="datetime"

                :picker-options="pickerOptions"
                @change="handleEndTimeChange"
                placeholder="选择结束时间">
              </el-date-picker>
            </div>
            <div class="searchBtnWrap">
              <img @click="filterPlane" src="../../assets/img/2dmap/shai_xuan_click.png">
            </div>
          </div>
          <div class="planeCheckbox">
            <el-checkbox-group
              @change="handleChange"
              v-model="checkedPlane">
              <el-checkbox size="medium" :disabled="isPlay" v-for="v in planeData" :label="v" :key="v">{{ v }}
              </el-checkbox>
            </el-checkbox-group>
            <!-- <div class="emptyPlane" :style="{display:planeData.length?'none':'block'}">暂无数据</div> -->
            <div class="emptyWrap" v-if="planeData.length == 0">
            <Empty  />
          </div>
          </div>
          <div class="progressWrap">
            <div class="timeBox">{{ timeStr }}</div>
            <el-progress :percentage="timeProgress" :stroke-width="4" :show-text="false" color="#00aeff"></el-progress>
          </div>
          <div class="handelWrap">
            <div style="display: flex;">
              <div>
                <img @click="handlePlay()"  :src="isPlay?require('../../assets/img/2dmap/pause.png'):require('../../assets/img/2dmap/play.png')">
                <span>{{ isPlay ? '暂停' : '播放' }}</span>
              </div>
              <div>
                <img @click="handlePlayBack(4)"  src="../../assets/img/2dmap/stop.png">
                <span>停止</span>
              </div>
            </div>
            <el-select v-model="speed" @change="handlePlayBack(1,speed)">
              <template #prefix>
                <span class="speedText">倍速 :</span>
              </template>
              <el-option
                v-for="item in speedOptions"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>


        </div>
      </div>
      <div id="rightOverlay" v-show="show2DMap">
        <div id="changeMapBtns" :style="{right:isDetailOpen?'100%':'0'}">
          <div class="btn" style="margin-right: 8px" @click="clickRoad()">
            <img
              :src="
            require(`../../assets/img/${isStyleApplied?'2dmap_eyes':'2dmap'}/${clickroad ? 'luwangtu_click' : 'luwangtu'}.png`)
          "
              alt=""
            />
          </div>
          <div class="btn" @click="clickStar()">
            <img
              :src="
            require(`../../assets/img/${isStyleApplied?'2dmap_eyes':'2dmap'}/${clickstar ? 'weixingtu_click' : 'weixingtu'}.png`)
          "
              alt=""
            />

          </div>
        </div>
        <div class="changeOneMenu">
          <div class="airSpaceBtn">
            <div
              class="chooseBtn"
              :class="airSpaceChecked ? 'active' : ''"
              title="空域"
              @click="
              handdelAirSpace
            "
            >
              <img :src="require(`../../assets/img/${isStyleApplied?'2dmap_eyes':'2dmap'}/${airSpaceChecked
            ? 'kong_yu_click'
            : 'kong_yu_normal'
            }.png`)
            " alt="" />
            </div>
            <div
              class="chooseBtn"
              :class="shibeiChecked ? 'active' : ''"
              title="设备"
              @click="
              shibeiChecked = !shibeiChecked;
              equip=!equip
            "
            >
              <img
                :src="
                require(`../../assets/img/${isStyleApplied?'2dmap_eyes':'2dmap'}/${
                  shibeiChecked ? 'she_bei_click' : 'she_bei_normal'
                }.png`)
              "
                alt=""
              />
            </div>

            <div
              class="chooseBtn"
              :class="airPointLineChecked ? 'active' : ''"
              title="航线/点/迹"
              @click="
               handelairPointLine
            "
            >
              <img
                :src="
                require(`../../assets/img/${isStyleApplied?'2dmap_eyes':'2dmap'}/${
                  airPointLineChecked ? 'fei_xing_click' : 'fei_xing_normal'
                }.png`)
              "
                alt=""
              />
            </div>
            <div
              class="chooseBtn"
              title="工具"
              :class="gongjuChecked ? 'active' : ''"
              @click="
              gongjuChecked = !gongjuChecked;
              gongju = !gongju
            "
            >
              <img
                :src="
                require(`../../assets/img/${isStyleApplied?'2dmap_eyes':'2dmap'}/${
                  gongjuChecked ? 'gong_ju_click' : 'gong_ju_normal'
                }.png`)
              "
                alt=""
              />
            </div>
          </div>
        </div>
        <div class= 'changeWithOpen1'>
          <!-- 右侧 -->
          <div class="airSpaceBtn" style="width: 100%;height: 100%;">
            <div v-show="area" class="area">
              <div
                class="chooseBtn"
                :class="showAirSpace ? 'Active' : 'noActive'"
              >
                <div @click="callairSpace">空域管理</div>
              </div>
              <div class='changeWithOpenXianArea'>

              </div>
            </div>
            <div v-show="equip" class="equip">
              <div
                class="chooseBtn"
                :class="active2 ? 'Active' : 'noActive'"

              >
                <div @click="callShowSign">标牌</div>
              </div>
              <div
                class="chooseBtn"
                :class="!isSimplifyTooltip ? 'Active' : 'noActive'"
              >
                <div  @click="changeTooltipBtn">详细标牌</div>
              </div>
              <div class='changeWithOpenXianEquip'>

              </div>
            </div>
            <div v-show="airPointLine" class="airPointLine">
              <div
                class="chooseBtn"
                :class="active1 ? 'Active' : 'noActive'"
              >
                <div @click="
                    callplayWay();
                  ">航迹
                </div>
              </div>
              <div
                class="chooseBtn"
                :class="showNormalairPort ? 'Active' : 'noActive'"
              >
                <div @click="
                    debouncedChangeormalAirPot();
                  ">航点
                </div>
              </div>
              <div
                class="chooseBtn"
                :class="showairPort ? 'Active' : 'noActive'"

              >
                <div @click="
                    debouncedChangeAirPot();
                  ">起降点
                </div>
              </div>
              <div
                class="chooseBtn"
                :class="showDubuleLine ? 'Active' : 'noActive'"

              >
                <div  @click="debouncedChangeLine();">切换航线</div>
              </div>
               <div class="chooseBtn" :class="showAirLineName ? 'Active' : 'noActive'">
                <div @click="changeAirLineName">航线名</div>
              </div>
              <div
                class="chooseBtn"
                :class="showAirLine ? 'Active' : 'noActive'"
              >
                <div @click="callPlanWay">航线管理</div>
              </div>
              <div class='changeWithOpenXianAirPointLine'>

              </div>
            </div>
            <div v-show="gongju" class="gongju">
              <div
                class="chooseBtn"
                :class="isCircle ? 'Active' : 'noActive'"
              >
                <div   @click=" addCircles ">距离环</div>
              </div>
               <div
                class="chooseBtn"
                :class="showRange ? 'Active' : 'noActive'"
              >
                <div @click="
                        enablePolylineDrawing();
                      ">测距
                </div>
              </div>
              <div class='changeWithOpenXiangongju'>

              </div>
            </div>
          </div>
        </div>
        <planDetail v-if="false" :clickPlaneInfo="clickPlaneInfo" :planeDetailData="planeDetailData"
                    :isDetailOpen="isDetailOpen"
                    :planeChartData="planeChartData"
                    :changeDetailOpen="changeDetailOpen">
        </planDetail>
      </div>
      <!-- 搜索对话框 -->
      <div id="container">
        <el-dialog
          title="搜索飞机"
          :visible.sync="searchFormVisible"
          width="30%"
          :close-on-click-modal="false"
          top="30vh"
        >
          <div class="searchContent">
            <el-form :model="searchForm" ref="formRef">
              <el-form-item>
                <el-select
                  v-model="searchForm.uasID"
                  placeholder="请输入飞机序列号"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in uavSerials"
                    :key="item.id"
                    :label="item.uasID"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer" class="bottomBtn">
              <el-button type="text" class="btnTxt" @click="handleSearch">搜索</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
    <div class="searchContent">
      <el-form :model="searchForm" ref="formRef">
        <el-form-item>
          <div class="searchContent1">
            <el-select v-model="searchForm.uasID" placeholder="请输入飞机序列号" filterable clearable
                       @change="handleSearch">
              <el-option v-for="item in uavSerials" :key="item.id" :label="item.uasID" :value="item.id"></el-option>
              <i slot="prefix" @click="handleSearch" class="el-input__icon el-icon-search"></i>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
      <!--      <div-->
      <!--        id="radarCanvasWrap" @dblclick="torAdarDerail">-->
      <!--        <canvas id="radarChart" width="280" height="280"></canvas>-->
      <!--      </div>-->
    </div>
    <div v-if="showAirLine">
      <el-container>
        <el-header style="height: 54px !important;">
          <span class="spanSize"> 航线管理</span>
          <el-button
            size="small"
            :class="showlineall ? 'showAllBtnActive' :'showAllBtn'"
            @click="showAll()"
          >显示全部
          </el-button>

        </el-header>
        <el-main class="main-container">
          <div>
            <el-table height="288px" :data="tableData">
              <el-table-column align="center" prop="name" label="航线名称" min-width="70">
              </el-table-column>
              <el-table-column prop="updatedAt" label="更新时间" min-width="90">
              </el-table-column>
              <el-table-column prop="isShowLine" label="航线" min-width="20">
                <template #default="scope">
                  <el-checkbox @change="(v) => { handelShowLine(v, scope.row.id) }"
                               v-model="scope.row.isShowLine"></el-checkbox>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-main>
      </el-container>
    </div>
    <div v-if="showAirSpace">
      <el-container>
        <el-header style="height: 54px !important;">
          <span class="spanSize"> 空域管理</span>
          <el-button
            size="small"
            :class="showAirspaceAll ? 'showAllBtnActive' :'showAllBtn'"
            @click="showAllAirSpace()"
          >显示全部
          </el-button>

        </el-header>
        <el-main class="main-container">
          <el-table height="288px" :data="airSpaceTableData">
            <el-table-column prop="airspaceName" label="名称" min-width="100">
            </el-table-column>
            <el-table-column prop="TYPE" label="类型" min-width="80">
              <template slot-scope="scope">
                {{ getTypeText(scope.row.TYPE) }}
              </template>
            </el-table-column>
            <el-table-column prop="COLOR" label="颜色" min-width="40">
              <!-- <template slot-scope="scope">
                  <div class="scopeColor" :style="{background:scope.row.COLOR}"></div>
                </template> -->
            </el-table-column>
            <el-table-column prop="STARTTIME" label="开始时间" min-width="90">
            </el-table-column>
            <el-table-column prop="ENDTIME" label="结束时间" min-width="90">
            </el-table-column>
            <el-table-column prop="isShowAirSpace" label="显示" min-width="40">
              <template #default="scope">
                <el-checkbox @change="(v) => { handelShowAirSpace(v, scope.row.id) }"
                             v-model="scope.row.isShowAirSpace"></el-checkbox>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </div>
  </div>


</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.heat";
import "leaflet-velocity";
import {wgs84ToGcj02, gcj02ToWgs84} from "../../../src/assets/js/map/ConverseLngAndLa";
import featurePanel from "./FeaturePanel";
import meteorologyPanel from "./MeteorologyPanel.vue";
import planDetail from "./PlanDetail.vue";
import "leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/leaflet.markercluster.js';
import 'leaflet-rotatedmarker';
import {timestampToHss} from "../../utils/tools"
import _ from 'lodash';
import Empty from "../../common/Empty.vue";
import ThreedPlayback from "../../components/home/ThreedPlayback"

export default {
  name: "FlightPlayback",
  props: {
    //父组件传递的数据
    isStyleApplied: {
      type: Boolean,
      default: true
    },
  },
  components: {
    featurePanel,
    meteorologyPanel,
    planDetail,
    Empty,
    ThreedPlayback
  },
  data() {
    return {
      typeMap: {
        1: 30,  // 多旋翼
        2: 45,  // 复合翼
        3: 60,  // ADSB
        4: 30,  // 反制
        5: 60,  // eVTOL
        11: 45, // 车
      },
      typeMarkerSizeMap: {
        1: "planeMarkerImg30",  // 多旋翼
        2: "planeMarkerImg45",  // 复合翼
        3: "planeMarkerImg60",  // ADSB
        4: "planeMarkerImg30",  // 反制
        5: "planeMarkerImg60",  // eVTOL
        11:"planeMarkerImg45", // 车
      },
      showAirLineName: true,
      showRange: false, //测距
      cityLayer:null,
      gongjuChecked:false,
      airSpaceChecked:false,
      shibeiChecked:false,
      airPointLineChecked:false,
      area:false,
      gongju:false,
      airPointLine:false,
      showairPort: true,//显示隐藏起降点
      showNormalairPort: false,//显示隐藏普通航点
      equip:false,
      singalNum: 0,
      showAirspaceAll: true,
      lineLength: {},//单条航迹的长度
      allLineLength: {}, //所有航迹点长度
      showDubuleLine: false,
      planKeyWord: '',//任务搜索关键词
      airSpaceTableData: [],
      showAirSpace: false,
      tableData: [],
      showAirLine: false,
      showlineall: true,
      isPlay: false,
      timeStr: '0:00/00:00',
      timeProgress: 0,
      show2DMap: true,
      websocketId: null,
      clickPlane: null,
      planeChartData: [],//飞机高度速度曲线数据
      planeDetailData: {},//飞机详情数据
      isSimplifyTooltip: true,//是否精简标牌
      clickPlaneId: '',//显示实时飞行的飞机号
      clickPlaneInfo: {},//显示实时飞行的飞机详情
      openLeft: true,//左侧开关
      isDetailOpen: false,
      active1: false, //航迹是否点击
      active2: false,
      active3: false,
      active4: false,
      active5: false,
      active6: false,
      speedOptions: [1, 2, 4, 8],
      speed: 1,
      i: 0,
      map: null,
      // center: [32.06, 118.8],//南京
      // center: [24.9402, 118.1806],//南安
      // center: [25.20249487751626, 118.44143629074098],//南安九都镇
      center: [31.2995549, 121.4511],//上海市静安区
      // center: [34.34,108.80], //西咸新区
      activeLayer: 0, //目前的图层
      isEnvelope: true, //是否显示包络
      clickstar: true,
      clickroad: false,
      currentZoom: 1, //当前地图缩放级别
      originLayer:
        "http://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}",
      roadUrlTemplate:
        "https://wprd01.is.autonavi.com/appmaptile?langzh_cn&size=1&scale=1&style=8{ltype}&x={x}&y={y}&z={z}",
      satelliteUrlTemplate:
        "https://webst01.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}",
      //数据
      showWeather: false, //气象是否点击
      alarmed: false,
      warninged: false,
      tooltipPermanent: false, //标牌展示隐藏
      updateTooltip: false, //是否进行更新标牌显隐属性操作
      infoArr: [], //多个航点实时数据
      uasId: null, //点击的当前点要展示航迹的点id
      openPopup: false, //是否展示锁定航点的弹框
      oldOrderId: [], //所有orderID
      markerPointData: [], //地图上创建的所有航点以及对应航点信息
      runTask: [], //执行中计划
      preTask: [], //待执行计划
      realTask: [], //预警告警事件
      // alarmMarker: [], //预警告警点数据
      meteoActive: 0, //当前气象模式

      //地图内容(可能需要清除)

      //正在执行

      //单个
      polyline: null, //单个航迹（当前点击的）
      trackLines: [], // 包含实线和虚线的航迹数组
      runlineWhites: [], //单个航迹白底
      //所有执行中
      markerPoints: [], //所有实时更新的飞行器
      runLineMarkers: [], //所有执行航线的（航点）
      runLines: [], //所有执行中的航线
      runRoadWhites: [], //航线白底
      allPolyline: [], //所有实时航迹
      allPolylines: [], //航迹白底

      //计划待执行
      //单个
      positionLines: null, //定位的航线
      positRoadWhite: null, //定位航线的白底

      //所有计划待执行
      airLinePositions: [], //所有当前定位航线的航点
      airLinePorts: [], //所有计划航线的（航点）
      planLines: [], //所有计划航线
      planlineWhite: [], //航线白底

      //所有数据
      airSpaces: [], //所有空域
      airPorts: [], //所有航点（包含起降点）

      //其他
      heatLayer: null, //绘制的热力图
      velocityLayer: null, //绘制的风速矢量图
      weatherInfo: {
        province: "",
        city: "",
        reporttime: "",
        temperature: "",
        winddirection: "",
        windpower: ""
      }, //气象数据
      imgCondition: {
        sunny: false,
        rain: false,
        cloudy: false, //多云
        yin: false
      }, //气象图片
      runMarkers: [], //getlastpoint接口获取的点
      toolTip: "",
      runPlaneID: [], //正在执行的飞机的ID
      distanceLabels: [], // 用于存储距离标签
      circles: [],// 创建圆环数组
      centerMarker: null, //圆环中心标记
      isCircle: false, //距离环是否开启
      markers: null, // 标记聚合
      searchFormVisible: false, //搜飞机的对话框
      searchForm: {
        uasID: '', // 飞机序列号
      },
      uavSerials: [], // 飞机序列号列表
      ws: null, // WebSocket连接
      isMannualClose: false, // 是否手动关闭
      southWestLat: '', // 西南角纬度
      southWestLng: '', // 西南角经度
      northEastLat: '', // 东北角纬度
      northEastLng: '', // 东北角经度
      singleLine: [],
      searchKey3: '', //搜索执行中的计划
      searchKey2: '', // 搜索待执行的计划
      searchKey1: '', // 搜索实时事件
      countermeasurePopMakers: [],//反制功能marker
      checkedPlane: [], // 选中的飞机
      // startTime: this.getInitialTime(-30), // 回放日期查询
      startTime: new Date('2024-12-28 12:03:00'), // 回放日期查询
      endTime: new Date('2024-12-28 12:33:00'), // 回放日期查询
      pickerOptions: {
        disabledDate: (time) => {
          const now = new Date();
          // 限制选择的最大日期为当前时间
          return time.getTime() > now.getTime();
        },
      },
      planeData: [],//日期查询飞机数据
    }
  },

  mounted() {
    this.initMap();
    this.planeAllWay();
    this.airSpace()
    window.addEventListener("message", e => {
      if (e.data == "changeLayerType") {
        if (this.active3) {
          this.planeAllWay();
        }
        if (this.active4) {
          this.airSpace();
        }
      }
    });
  },
  computed: {
    // startPickerOptions: {
    //   disabledDate: (time) => {
    //     return this.isDateOutOfRange(time, this.endTime, 1);
    //   }
    // },
    // endPickerOptions: {
    //   disabledDate: (time) => {
    //     return this.isDateOutOfRange(time, this.startTime, -1);
    //   }
    // }
    // endPickerOptions() {
    //   return {
    //     disabledDate: (time) => {
    //       // 限制结束时间只能选择当天
    //       const startDate = this.startTime ? new Date(this.startTime).setHours(0, 0, 0, 0) : null;
    //       const selectedDate = time.setHours(0, 0, 0, 0);
    //       // 结束时间只能是开始时间的当天
    //       return startDate && selectedDate !== startDate;
    //     }
    //   };
    // },
  },
  beforeDestroy() {
    if (window.queryTimer) {
      clearInterval(window.queryTimer);
      window.queryTimer = null;
    }
    if (window.weatherTimer) {
      clearInterval(window.weatherTimer);
      window.weatherTimer = null;
    }
    if (window.predictionTimer) {
      clearInterval(window.predictionTimer);
      window.predictionTimer = null;
    }
    this.ws.close()
    this.ws = null;
  },
  created() {
    // 创建防抖函数
    this.debouncedChangeLine = _.debounce(this.changeLineShow, 500);
    this.debouncedChangeAirPot = _.debounce(this.changeAirPotShow, 500);
    this.debouncedChangeormalAirPot = _.debounce(this.changeNormalAirPotShow, 500);
  },
  methods: {
    handelairPointLine(){
      this.airPointLineChecked = !this.airPointLineChecked;
      this.airPointLine = !this.airPointLine;
      if(!this.airPointLineChecked){
        if(this.showAirLine){
          this.showAirLine = false;
        }
      }
    },
      handdelAirSpace(){
      this.airSpaceChecked = !this.airSpaceChecked;
      this.area = !this.area;
      if(!this.airSpaceChecked){
        this.showAirSpace = false;
      }
    },
    //切换航线名显示隐藏
    changeAirLineName(){
      this.showAirLineName = !this.showAirLineName
        this.planLines.map(v=>{
          if(this.showAirLineName && this.currentZoom > 10){
            v.openTooltip();
          }else{
            v.closeTooltip();
          }
        })
    },
    //更新航线toolTip name 是否展示
    updateAirLineNameStatus() {
      if (this.planLines.length) {
        const shouldBe= this.currentZoom > 10;
        this.planLines.forEach((line) => {
          if(shouldBe){
            line.openTooltip()
          }else {
            line.closeTooltip()
          }
        });
      }
    },
    showMask() {
      // 加载城市的 GeoJSON 数据
      this.getRequest("/uav-task-server/airspace/getShanghaiGeoJson").then(res => {
        const oData = res.data;
        if (oData.code === 0) {
          const cityGeoJSON = JSON.parse(oData.data);
          // 创建一个城市图层
          // 创建城市的图层并添加到地图
          this.cityLayer = L.geoJSON(cityGeoJSON, {
            style: {
              color: this.isStyleApplied?'rgba(214,211,241,1)':'rgba(255,254,190,1)', // 城市边界颜色
              weight: 2,
              fillColor: this.isStyleApplied?'rgb(219,217,255,0.48)':'rgb(255,246,141,0.48)', // 填充颜色
              fillOpacity: 0.48, // 填充透明度
            }
          }).addTo(this.map);
          // // 调整地图视图以适应城市边界
          // const cityBounds = L.geoJSON(cityGeoJSON).getBounds();
          // this.map.fitBounds(cityBounds); // 自适应地图视图
        }
      });
    },
    getTypeText(type) {
      if (type === 0) {
        return '禁飞区';
      } else if (type === 1) {
        return '电子围栏';
      } else if (type === 3) {
        return '适飞区';
      } else if (type === 4) {
        return '限飞区';
      } else if (type >= 11 && type <= 19) {
        return '管制空域';
      } else if (type >= 21 && type <= 29) {
        return '监视空域';
      }
      return '未知类型';
    },
    //切换航线显示
    changeLineShow() {
      this.showDubuleLine = !this.showDubuleLine
      this.planeAllWay()
    },
    changeAirPotShow() {
      if (this.airLinePorts.length > 0) {
        this.airLinePorts.forEach(point => {
          this.map.removeLayer(point);
        });
        this.airLinePorts = [];
      }
      if (this.airLinePositions.length > 0) {
        this.airLinePositions.forEach(marker => {
          this.map.removeLayer(marker);
          this.airLinePositions = [];
        });
      }
      this.showairPort = !this.showairPort
      let queryCode
      if (this.selectedDistrict == 0) {
        if (this.selectCity == 0) {
          queryCode = this.selectProvince
        } else {
          queryCode = this.selectCity
        }
      } else {
        queryCode = this.selectedDistrict
      }
      this.planeAllWay(queryCode)

    },
    changeNormalAirPotShow() {
      if (this.airLinePorts.length > 0) {
        this.airLinePorts.forEach(point => {
          this.map.removeLayer(point);
        });
        this.airLinePorts = [];
      }
      if (this.airLinePositions.length > 0) {
        this.airLinePositions.forEach(marker => {
          this.map.removeLayer(marker);
          this.airLinePositions = [];
        });
      }
      this.showNormalairPort = !this.showNormalairPort
      let queryCode
      if (this.selectedDistrict == 0) {
        if (this.selectCity == 0) {
          queryCode = this.selectProvince
        } else {
          queryCode = this.selectCity
        }
      } else {
        queryCode = this.selectedDistrict
      }
      this.planeAllWay(queryCode)

    },
    getIconUrl(info) {
      //uavType  1 多旋翼 2复合翼
      let iconUrl = "../../../static/wurenji_normal.png";
      if (info.uavType === 1) {
        if (info.alarm || info.warning || (info.conflictsList && info.conflictsList.length) || info.black) {
          iconUrl = "../../../static/wurenji_yichang.png";
        } else if (info.uasID === this.uasId) {
          iconUrl = "../../../static/wu_ren_ji__click.png";
        }
      } else if (info.uavType === 2) {
        if (info.alarm || info.warning || (info.conflictsList && info.conflictsList.length) || info.black) {
          iconUrl = "../../../static/feiji_yichang.png";
        } else if (info.uasID === this.uasId) {
          iconUrl = "../../../static/feiji_yichang_click.png";
        } else {
          iconUrl = "../../../static/feiji_normal.png";
        }
      } else if (info.uavType === 3) {
        iconUrl = "../../../static/civil_wurenji.png";
      } else if (info.uavType === 4) {
        iconUrl = "../../../static/wurenji_fanzhi.png";
      } else if (info.uavType === 5) {
        if (info.alarm || info.warning || (info.conflictsList && info.conflictsList.length) || info.black) {
          iconUrl = "../../../static/evtol_yichang.png";
        } else if (info.uasID === this.uasId) {
          iconUrl = "../../../static/evtol_click.png";
        } else {
          iconUrl = "../../../static/evtol_normal.png";
        }
      }
      return iconUrl;
    },

    // 获取告警信息的方法
    getAlarmDiv(info) {
      if (info.warning) {
        return "<div>预警:<span>即将偏离航线</span></div>";
      }
      if (info.alarm) {
        return "<div>告警:<span>已偏离航线</span></div>";
      }
      if (info.black) {
        return "<div>告警:<span>黑飞</span></div>";
      }
      return "";
    },

    createMarker(info, type) {
      const iconUrl = this.getIconUrl(info);
      let iconSize = this.typeMap[info.uavType]
      //设置图标样式
      let myIcon = L.divIcon({
        html: `<div id="planeMarker" class="planeMarker ${!this.isEnvelope ? 'planeMarkerActive' : ''} "  ><img src=${iconUrl} alt=" " class="${this.typeMarkerSizeMap[info.uavType]
          }"></div>`,
        className: "planeMarker", // 添加我们定义的CSS类
        // iconSize: 40
        iconSize: [iconSize, iconSize],
        iconAnchor: [iconSize / 2, iconSize / 2]
      });
      let point = wgs84ToGcj02(info.longtitude, info.latitude);
      let rotateAngle = info.course; //航迹角 正北方向为0度，顺时针旋转
      let markerPoint = L.marker([point[1], point[0]], {
        icon: myIcon,
        zIndexOffset: 9001, // 设置一个较高的z-index值
        rotationAngle: rotateAngle, //根据航迹角来进行飞机的旋转
        rotationOrigin: "center center", //设置旋转中心
        draggable: true
      }).addTo(this.map);
      //点添加标牌以及样式
      let planNoContent = info.planNo
        ? `<span>${info.planNo}</span>`
        : `<span>无计划</span>`;
      //告警预警
      var alarmDiv = "";
      if (info.warning) {
        alarmDiv = "<div>预警:<span>即将偏离航线</span></div>";
      }
      if (info.alarm) {
        alarmDiv = "<div>告警:<span>已偏离航线</span></div>";
      }
      if (info.black) {
        alarmDiv = "<div>告警:<span>黑飞</span></div>";
      }
      if (type === "envelope") {
        var iconElement = markerPoint.getElement();
        if (info.alarm || info.warning || info.black) {
          // 开始闪烁
          iconElement && iconElement.classList.add("blinking");
        } else if (!info.alarm && !info.warning && info.black) {
          // 停止闪烁
          iconElement && iconElement.classList.remove("blinking");
        }
      }
      //高度、速度、航迹角
      let altitude =
        info.altitude != null ? Number(info.altitude).toFixed(2) + " m" : "/";
      let gs = info.gs != null ? Number(info.gs).toFixed(2) + " m/s" : "/";
      let height = info.height != null ? Number(info.height).toFixed(2) + " m" : "/";
      let course = info.course != null ? info.course + " °" : "/";
      this.isSimplifyTooltip ? this.toolTip = `
        <div class="content">
        <div class='tag' >
                <div  style="overflow:hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 100%;">${info.uasID != null ? info.uasID : "/"}</div>
              <div >${info.modelName || info.uavModel || '/'}</div>
              <div>${altitude}</div>
              <div>${gs}</div>
          </div>
        </div>` :
        this.toolTip = `
        <div class="content">
          <div class="title" style="margin-left: 8px;overflow: hidden;width:200px;text-overflow: ellipsis;white-space: nowrap;">${info.uasID != null ? info.uasID : "/"}</div>
          <div class='tag'>
              <div >计划编号:${planNoContent}</div>
              <div >飞机型号:${info.modelName || info.uavModel || '/'}</div>
              <div >经度:<span>${info.longtitude != null
          ? this.decimalToDMS(info.longtitude)
          : "/"
        }</span>
              </div>
              <div >纬度:<span>${info.latitude != null ? this.decimalToDMS(info.latitude) : "/"
        }</span>
              </div>
              <div >海拔高:<span>${altitude}</span></div>
              <div >真高:<span>${height}</span></div>
              <div>速度:<span>${gs}</span></div>
              <div >航迹角:<span>${course}</span></div>
            ${alarmDiv}
          </div>
        </div>`;
      markerPoint.bindTooltip(this.toolTip, {
        //内容可以自定义为HTML，如：<div>自定义结构</div>
        autoPan: false,
        zIndexOffset: 1100,
        direction: "bottom", // 显示在底部
        permanent: this.tooltipPermanent || this.clickPlane === info.uasID, // 永久打开提示
        offset: [0, 15], // 向下偏移
        className: this.isSimplifyTooltip ? 'simplifyTooltip' : "anim-tooltip" // 自定义class
      });
      //飞机点击事件
      markerPoint.on("click", e => {
        this.singleLine = []; //清空航迹数组
        //更新图标颜色
        if (this.uasId !== info.uasID) {
          //开启实时更新航线
          this.openPopup = true;
          this.uasId = info.uasID;
          setTimeout(()=>{
            this.deletePolyAllline();
            this.addPolyline(this.uasId); // 点击后请求后端接口绘制航迹
          },2000/this.speed)
          //获取飞机详情速度高度曲线数据
          this.clickPlaneId = info.uasID
          this.clickPlane = info.uasID
        } else if (this.uasId === info.uasID) {
          setTimeout(()=>{
            this.deletePolyAllline();
          },2000/this.speed)
          this.uasId = null;
        }
        this.markerPointData.map(item => {
          const newIconUrl = this.getIconUrl(item.info)
          let newHtml = `<div id="planeMarker" class="planeMarker ${!this.isEnvelope ? 'planeMarkerActive' : ''} "  ><img src=${newIconUrl} alt=" " class="${this.typeMarkerSizeMap[item.info.uavType]
            }"></div>`;
          const newIcon = L.divIcon({
            html: newHtml,
            className: "planeMarker",
            iconSize: [item.markerPoint.options.icon.options.iconSize[0], item.markerPoint.options.icon.options.iconSize[1]],
            iconAnchor: [item.markerPoint.options.icon.options.iconAnchor[0], item.markerPoint.options.icon.options.iconAnchor[1]]
          });
          //更新点击飞机图标
          item.markerPoint.setIcon(newIcon);
          //更新标牌
          item.markerPoint.bindTooltip(this.toolTip, {
            //内容可以自定义为HTML，如：<div>自定义结构</div>
            autoPan: false,
            zIndexOffset: 1100,
            direction: "bottom", // 显示在底部
            permanent: this.tooltipPermanent || this.clickPlane === item.info.uasID, // 永久打开提示
            offset: [0, 15], // 向下偏移
            className: this.isSimplifyTooltip ? 'simplifyTooltip' : "anim-tooltip" // 自定义class
          });
        })
      });

      var iconElement = markerPoint.getElement();
      if (info.alarm || info.warning || info.black) {
        // 开始闪烁
        iconElement && iconElement.classList.add("blinking");
      } else if (!info.alarm && !info.warning && info.black) {
        // 停止闪烁
        iconElement && iconElement.classList.remove("blinking");
      }
      this.markerPoints.push(markerPoint);
      this.markerPointData.push({markerPoint: markerPoint, info: info});
    },
    handelShowLine(v, id) {
      this.deletePlaneAllWay()
      this.planeAllWay()
    },
    handelShowAirSpace(v, id) {
      this.daleteAirSpace()
      this.airSpace()
    },
    showAll() {
      if (!this.showlineall) {
        this.tableData.forEach(v => {
          v.isShowLine = true
        })
        this.deletePlaneAllWay()
        this.planeAllWay()
        this.showlineall = !this.showlineall
      } else {
        this.tableData.forEach(v => {
          v.isShowLine = false
        })
        this.deletePlaneAllWay()
        this.showlineall = !this.showlineall
      }
    },
    showAllAirSpace() {
      if (!this.showAirspaceAll) {
        this.airSpaceTableData.forEach(v => {
          v.isShowAirSpace = true
        })
        this.daleteAirSpace()
        this.airSpace()
        this.showAirspaceAll = !this.showAirspaceAll
      } else {
        this.airSpaceTableData.forEach(v => {
          v.isShowAirSpace = false
        })
        this.daleteAirSpace()
        this.showAirspaceAll = !this.showAirspaceAll
      }
    },
    handlePlay() {
      this.isPlay = !this.isPlay
      if (this.isPlay) {
        this.handlePlayBack(2)
      } else {
        this.handlePlayBack(3)
      }
    },
    changeMap() {
      this.show2DMap = !this.show2DMap
      this.$nextTick(() => {
        if (!this.show2DMap) {
          this.sendMessage(this.websocketId)
        }
      })
    },
    sendMessage(val) {
      this.$nextTick(() => {
        const iframe = document.getElementById('mapframe');
        const message = {type: 'data', content: val};
        iframe.contentWindow.postMessage(message, '*'); // 发送消息给 iframe
      })
    },
    initMap() {
      //定义图层样式
      var layer = L.tileLayer(
        this.satelliteUrlTemplate
        // "http://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}"
      );
      //创建地图
      var map = L.map("map-container", {
        center: this.center, //中心坐标
        // zoom: 10, //缩放级别
        zoom: 15, //缩放级别
        minZoom: 3,
        maxZoom: 18,
        zoomControl: true, //缩放组件
        attributionControl: false, //去掉右下角logol
        layers: [layer] //图层
      });
      this.map = map;
      this.currentZoom = map.getZoom()
      this.showMask() //遮罩
      let _this = this;
      // 初始化Leaflet.draw控件
      var drawnItems = new L.FeatureGroup();
      this.map.addLayer(drawnItems);
      // 绘制控件初始化代码...
      this.drawControl = new L.Control.Draw({
        draw: {
          polyline: {
            shapeOptions: {
              color: "red", // 设置绘制线条的颜色
              opacity: 0.8
            },
            allowIntersection: false,
            showLength: true,
            metric: true // 使用公制单位进行测量
          },
          polygon: false,
          rectangle: false,
          circle: false,
          marker: false,
          circlemarker: false,
        }
      });
      // 将绘制控件添加到地图上
      this.map.addControl(this.drawControl);

      // 地图加载完成后再执行操作
      map.whenReady(() => {
        // // 创建初始圆环
        // _this.createCircles();
        _this.$emit('update-theme')
        // 监听地图移动事件
        map.on("moveend", function () {
          _this.$emit('update-theme')
          _this.updateCirclesPosition();
          // _this.getBounds();
          // _this.sendBounds();
        });
        //监听地图缩放
        map.on("zoomend", function () {
          _this.$emit('update-theme')
          // 获取当前缩放级别
          _this.currentZoom = map.getZoom();
          // _this.updatePolylineWeight();
          _this.updateCirclesPosition();
          if(_this.showAirLineName){
            _this.updateAirLineNameStatus()
          }
          // _this.getBounds();
          // _this.sendBounds();
        });
        //定位用户地理位置
        // this.getUserLocation();
        //生成随机websocketId
        this.websocketId = parseInt(new Date().getTime().toString().slice(-7))
        // this.websocketId  =  1234567
        this.getLastStatus(this.websocketId);
        // window.queryTimer = setInterval(this.getLastStatus, 2000);

        // 监听绘制事件
        let that = this;
        map.on("draw:created", function (event) {
          // 将绘制的图层添加到地图上
          var layer = event.layer;
          // 获取图层类型
          var layerType = event.layerType;
          drawnItems.addLayer(layer);
          that.drawnItems = drawnItems;
          if (layerType === "polyline") {
            // 确保 layer 对象存在
            if (layer) {
              // 获取线上的所有顶点
              let latlngs = layer.getLatLngs();
              // 初始化一个数组来存储所有顶点的坐标
              let points = [];
              latlngs.forEach(item => {
                points.push([item.lng, item.lat]);
              });
              // console.log('顶点', points);
              // 初始化距离变量
              let totalDistance = 0;
              // 遍历所有顶点，‌计算相邻顶点之间的距离，‌并累加
              for (let i = 0; i < latlngs.length - 1; i++) {
                let startPoint = latlngs[i];
                let endPoint = latlngs[i + 1];
                // 计算两点之间的距离，‌并累加到总距离中
                totalDistance += startPoint.distanceTo(endPoint);
              }
              const distanceLabel = L.divIcon({
                className: 'distance-label',
                html: `<div class="distance"><span class="label">共${(totalDistance / 1000).toFixed(2)} km</span><span id="close-icon-${layer._leaflet_id}"><i class="el-icon-close"></i></span></div>`,
              });
              const labelPosition = layer.getLatLngs()[layer.getLatLngs().length - 1];
              const marker = L.marker(labelPosition, {icon: distanceLabel});
              that.showRange = false
              marker.on('add', function () {
                const closeIconId = `close-icon-${layer._leaflet_id}`;
                const closeIcon = document.getElementById(closeIconId);
                if (closeIcon) {
                  closeIcon.addEventListener('click', () => {
                    that.handleDeleteDistance(layer, marker);
                  });
                }
              });
              marker.on('remove', function () {
                const closeIconId = `close-icon-${layer._leaflet_id}`;
                const closeIcon = document.getElementById(closeIconId);
                if (closeIcon) {
                  closeIcon.removeEventListener('click', () => {
                    that.handleDeleteDistance(layer, marker);
                  });
                }
              });
              map.addLayer(marker);
              that.distanceLabels.push({layer, label: distanceLabel});
            } else {
              console.error('Layer is undefined or null');
            }
          }
        });

      });
    },
    getInitialTime(minutes) {
      const now = new Date();
      now.setMinutes(now.getMinutes() + minutes);
      return now;
    },
    // isDateOutOfRange(selectedDate, referenceDate, maxDays) {
    //   if (!selectedDate ||!referenceDate) {
    //     return false;
    //   }
    //   const timeDiff = Math.abs(selectedDate - referenceDate);
    //   const oneDayInMillis = 24 * 60 * 60 * 1000;
    //   return timeDiff > oneDayInMillis * Math.abs(maxDays);
    // },
    handleStartTimeChange(newStartTime) {
      // 将结束时间往后推半小时
      this.endTime = new Date(newStartTime.getTime() + 30 * 60 * 1000);

      // 检查结束时间是否大于开始时间
      if (this.endTime <= newStartTime) {
        this.endTime = new Date(newStartTime.getTime() + 30 * 60 * 1000); // 确保结束时间大于开始时间
      }

      // 检查结束时间是否超过开始时间加一天
      const maxEndTime = new Date(newStartTime.getTime() + 24 * 60 * 60 * 1000);
      if (this.endTime > maxEndTime) {
        this.endTime = maxEndTime; // 调整结束时间为开始时间加一天
      }
    },
    handleEndTimeChange(newEndTime) {
      // 检查开始时间是否大于结束时间
      if (this.startTime >= newEndTime) {
        this.startTime = new Date(newEndTime.getTime() - 30 * 60 * 1000); // 确保开始时间小于结束时间
      }
      const maxEndTime = new Date(this.startTime.getTime() + 24 * 60 * 60 * 1000);
      if (this.endTime > maxEndTime) {
        // this.$message('时间间隔不能超过一天')
        this.$message({
          message: "时间间隔不能超过一天",
          duration: 1000,
          offset: 470,
          onClose: function () {
          }
        });
        this.endTime = maxEndTime; // 调整开始时间为结束时间减一天
      }
    },

    handleChange(newValue) {
      // 如果选中项有值，更新 checkedPlane 以确保单选
      // if (newValue.length > 0) {
      //   this.checkedPlane = [newValue[newValue.length - 1]] // 只保留最后选中的值
      // }
      this.checkedPlane = newValue
    },
    handlePlayBack(type, speed) {
      if (type === 4) {

      }
      if (!this.checkedPlane.length) {
        return
      }
      //type 2播放 3暂停 4停止 1倍数
      switch (type) {
        case 1:
          this.ws.send(JSON.stringify({command: 5, speed: speed}));
          break;
        case 2:
          this.ws.send(JSON.stringify({command: 2, uavList: this.checkedPlane, speed: speed}));
          break;
        case 3:
          this.ws.send(JSON.stringify({command: 3}));
          break;
        case 4:
          this.ws.send(JSON.stringify({command: 4}));
          this.isPlay = false;
          this.clearAllLine();
          break;
      }

    },
    changeDetailOpen(v) {
      this.isDetailOpen = v
    },
    formatReplayDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      // 拼接成 yyyy-MM-dd HH:mm:ss 格式
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    filterPlane() {
      this.isPlay = false
      if (!(this.startTime || this.endTime)) {
        this.planeData = []
        return
      }
      const obj = {
        startTime: this.formatReplayDate(this.startTime),
        endTime: this.formatReplayDate(this.endTime),
        command: 1
      }
      this.ws.send(
        JSON.stringify(obj)
      )
      //全选
      setTimeout(() => {
        this.checkedPlane = this.planeData
      }, 500)
    },
    callplayWay() {
      this.active1 = !this.active1;
      // if (this.active1) {
      //   this.addPolyAllline();
      // } else {
      //   this.deletePolyAllline();
      // }
      this.handleChildMessage(this.active1)
      // this.$emit("messageFromChild", this.active1);
    },
    callPlanWay() {
      this.active3 = !this.active3;
      // if (this.active3) {
      //   this.planeAllWay();
      // } else {
      //   this.deletePlaneAllWay();
      // }
      if (this.showAirSpace) {
        this.showAirSpace = false
      }
      this.showAirLine = !this.showAirLine
    },
    callairSpace() {
      if (this.showAirLine) {
        this.showAirLine = false
      }
      this.active4 = !this.active4;
      // if (this.active4) {
      //   this.airSpace();
      // } else {
      //   this.daleteAirSpace();
      // }
      this.showAirSpace = !this.showAirSpace
    },
    callairport() {
      this.active5 = !this.active5;
      if (this.active5) {
        this.airPort();
      } else {
        this.daleteAirPort();
      }
    },
    callweather() {
      this.active6 = !this.active6;
      this.handleWeather(this.active6)
      // this.$emit("messageWeather", this.active6);
      if (this.active6) {
        // this.airPort();
      } else {
        // this.daleteAirPort();
      }
    },
    callShowSign() {
      this.active2 = !this.active2;
      if (this.active2) {
        this.isSimplifyTooltip = true
        this.changeSign(true);
      } else {
        this.changeSign(false);
      }
      this.addMarker();
    },

    // 模拟用户点击折线绘制按钮
       enablePolylineDrawing() {
      this.showRange = !this.showRange
      if (this.showRange) {
        var polylineButton = document.getElementsByClassName(
          "leaflet-draw-draw-polyline"
        )[0];
        if (polylineButton) {
          polylineButton.click();
        }
      }else{
        const cancelButton = document.querySelector('.leaflet-draw-actions a[title="Cancel drawing"]');
        if (cancelButton) {
          cancelButton.click();
        }
      }
    },
    // 处理删除按钮点击事件
    handleDeleteDistance(layerToDelete, markerToDelete) {
      this.map.removeLayer(layerToDelete);
      this.map.removeLayer(markerToDelete._icon);
      this.map.removeLayer(markerToDelete);
      this.distanceLabels = this.distanceLabels.filter(item => item.layer !== layerToDelete && item.label !== markerToDelete._icon);
    },

    addCircles() {
      this.isCircle = !this.isCircle;
      if (this.isCircle) {
        this.createCircles();
      } else {
        this.removeCircles();
      }
    },
    // 移除圆环
    removeCircles() {
      this.circles.forEach(circle => {
        this.map.removeLayer(circle);
      });
      this.circles = [];
      // 移除中心标记
      if (this.centerMarker) {
        this.map.removeLayer(this.centerMarker);
      }
      this.centerMarker = null;
    },
    // 创建圆环
    createCircles() {
      const center = this.map.getCenter();
      this.circles = [
        // 先画大圆，保证小圆在大圆的上层
        L.circle(center, {
          radius: 20000, // 半径20公里
          color: '#00FF00',
          weight: 2,
          opacity: 1,
          fillColor: '#00FF00',
          fillOpacity: 0.2
        }).addTo(this.map),
        L.circle(center, {
          radius: 10000, // 半径10公里
          color: '#FFFF00',
          weight: 2,
          opacity: 1,
          fillColor: '#FFFF00',
          fillOpacity: 0.2
        }).addTo(this.map),
        L.circle(center, {
          radius: 5000, // 半径5公里
          color: '#FF0000',
          weight: 2,
          opacity: 1,
          fillColor: '#FF0000',
          fillOpacity: 0.2
        }).addTo(this.map),
      ];
      // 在圆心添加中心标记
      const centerMarker = L.marker(center, {
        icon: L.divIcon({
          className: 'center-marker',
          html: '<div class="cross"><div class="line1"></div><div class="line2"></div></div>'
        })
      });
      centerMarker.addTo(this.map);
      this.centerMarker = centerMarker;

      // 为每个圆添加鼠标悬停事件
      this.circles.forEach(circle => {
        let popup;
        const that = this;

        function togglePopup(latlng, showPopup) {
          if (showPopup) {
            popup = L.popup({
              closeButton: false // 设置closeButton为false来隐藏关闭按钮
            })
              .setLatLng(latlng)
              .setContent(`距离不足 ${that.getOriginalDistance(circle) / 1000} 公里`)
              .openOn(that.map);
          } else {
            popup.close();
          }
        }

        circle.on('mouseover', function (e) {
          togglePopup(e.latlng, true);
        });
        circle.on('mouseout', function (e) {
          togglePopup(e.latlng, false);
        });
      });
    },
    // 更新圆环的位置
    updateCirclesPosition() {
      const center = this.map.getCenter();
      this.circles.forEach(circle => {
        circle.setLatLng(center);
        const originalDistance = this.getOriginalDistance(circle);
        circle.setRadius(originalDistance);
      });
      // 更新中心标记位置
      if (this.centerMarker) {
        this.centerMarker.setLatLng(center);
      }
    },
    getOriginalDistance(circle) {
      // 根据颜色再设置对应圆的半径
      if (circle.options.color === '#FF0000') {
        return 5000;
      } else if (circle.options.color === '#FFFF00') {
        return 10000;
      } else if (circle.options.color === '#00FF00') {
        return 20000;
      }
      return 5000;
    },

    handleChildMessage(message) {
      // 更新父组件的数据
      this.active1 = message;
      this.uasId = null;
      if (message) {
        //绘制所有航迹
        this.addPolyAllline();
      } else {
        setTimeout(() => {
          this.deletePolyAllline();
        }, 2000)
      }
    },
    //气象模式
    handleWeather(data) {
      this.showWeather = data;
      if(this.showWeather)
      this.getWeather();
    },
    getWeather() {
      this.getRequest(
        "/v3/weather/weatherInfo?city=350500&key=1d22a38b9f369f91704e4cd92fe5e35f"
      ).then(res => {
        let oData = res.data;
        if (oData.infocode == 10000) {
          this.weatherInfo = oData.lives[0];
          if (this.weatherInfo.weather.includes("晴")) {
            this.imgCondition.sunny = true;
          } else if (this.weatherInfo.weather.includes("雨")) {
            this.imgCondition.rain = true;
          } else if (this.weatherInfo.weather.includes("云")) {
            this.imgCondition.cloudy = true;
          } else {
            this.imgCondition.yin = true;
          }
        }
      });
    },
    //设置时间格式
    formatDate(weatherInfo) {
      const date = new Date(weatherInfo.reporttime);
      const year = date.getFullYear();
      const month = (1 + date.getMonth()).toString().padStart(2, "0");
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      return `${year}年${month}月${day}日`;
    },

    changeMeteo(data) {
      this.meteoActive = data;
      if (data != 0) {
        if (data == 6) {
          this.switchLayer("wind");
        } else {
          this.switchLayer("hot");
        }
      }
    },
    clickRoad() {
      this.handelShowLine()
      this.handelShowAirSpace()
      this.clickroad = !this.clickroad;
      if (this.clickroad) {
        this.clickstar = false;
        this.switchLayer("road");
      } else {
        this.switchLayer("back");
      }
    },
    clickStar() {
      this.handelShowLine()
      this.handelShowAirSpace()
      this.clickstar = !this.clickstar;
      if (this.clickstar) {
        this.clickroad = false;
        this.switchLayer("satellite");
      } else {
        this.switchLayer("back");
      }
    },
    async changeEnvelope() {
      this.isEnvelope = !this.isEnvelope
      //清空原本marker重新添加marker
      if (this.markerPointData) {
        this.markerPointData.forEach(item => {
          this.map.removeLayer(item.markerPoint);
        });
        this.markerPointData = [];
      }
      await this.addMarker("envelope")
    },
    //TOdo
    async changeTooltipBtn() {
      this.isSimplifyTooltip = !this.isSimplifyTooltip
      if(!this.isSimplifyTooltip){
        this.active2 = false
       this.changeSign(true);
      }else{
        this.changeSign(false);
      }
      this.addMarker();
    },
    switchLayer(layerType) {
      window.postMessage("changeLayerType", "*");
      // this.againPlaneWay();
      switch (layerType) {
        case "road":
          this.activeLayer = 1;
          // 移除现有图层并添加路网图层
          this.map.eachLayer(layer => {
            if (layer instanceof L.TileLayer) {
              this.map.removeLayer(layer);
            }
          });
          L.tileLayer(this.roadUrlTemplate, {
            ltype: "11",
            attribution: "高德地图路网"
          }).addTo(this.map);
          break;
        case "satellite":
          this.activeLayer = 2;
          // 移除现有图层并添加卫星影像图层
          this.map.eachLayer(layer => {
            if (layer instanceof L.TileLayer) {
              this.map.removeLayer(layer);
            }
          });
          L.tileLayer(this.satelliteUrlTemplate, {
            attribution: "高德地图卫星影像"
          }).addTo(this.map);
          break;
        case "hot":
          this.activeLayer = 3;
          // 定义热力点数量，加热力半径
          var heatNumbers = 150,
            heatRadius = 30;
          // 加热力坐标信息数组
          var heatPoints = [];
          // 遍历添加坐标信息
          for (var i = 0; i < heatNumbers; i++) {
            heatPoints[i] = [
              Math.random() * 0.28 + 39.78,
              Math.random() * 0.5 + 116.12,
              Math.random() * 80
            ];
          }
          if (this.heatLayer) {
            this.map.removeLayer(this.heatLayer);
          }
          if (this.velocityLayer) {
            this.map.removeLayer(this.velocityLayer);
          }
          // 调用渲染方法，传入半径，透明度参数，添加到地图
          this.heatLayer = L.heatLayer(heatPoints, {
            radius: heatRadius,
            minOpacity: 0.5
          }).addTo(this.map);

          break;
        case "wind":
          this.activeLayer = 3;
          var heatNumbers = 150,
            heatRadius = 30;
          // 加热力坐标信息数组
          var windData = [];
          // 遍历添加坐标信息
          for (var i = 0; i < heatNumbers; i++) {
            windData[i] = {
              lat: Math.random() * 0.28 + 39.78,
              lng: Math.random() * 0.5 + 116.12,
              angle: 45
            };
          }

          // 调用渲染方法，传入半径，透明度参数，添加到地图
          if (this.heatLayer) {
            this.map.removeLayer(this.heatLayer);
          }
          if (this.velocityLayer) {
            this.map.removeLayer(this.velocityLayer);
          }
          // 循环风向数据，绘制风向箭头
          var layer = windLayer(data);
          layer.addTo(this.map);

          break;
        // ... 同理添加其他图层
        case "back":
          this.activeLayer = 4;
          // 移除现有图层并添加路网图层
          this.map.eachLayer(layer => {
            if (layer instanceof L.TileLayer) {
              this.map.removeLayer(layer);
            }
          });
          L.tileLayer(this.originLayer, {
            attribution: "高德原影像"
          }).addTo(this.map);
          break;
      }
    },
    //获取飞机速度高度曲线数据
    getChartData(uasId) {
      this.getRequest(
        `/uav-task-server/point/getGsAltitudeTimeCurve?uasID=${uasId}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          this.planeChartData = oData.data
        } else {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            },
          });
        }
      });
    },
    //获取飞机详细信息
    getPlaneDetailData(uasId, planNo) {
      this.getRequest(
        `/uav-task-server/plandto/getAircraftDetail?orderID=${planNo}&uavSerial=${uasId}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          this.planeDetailData = oData.data
        } else {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            },
          });
        }
      });
    },
    //定位用户地理位置
    getUserLocation() {
      let _this = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            var lat = position.coords.latitude;
            var lon = position.coords.longitude;
            // 缩放级别 1: 整个世界
            // 缩放级别 5: 大洲
            // 缩放级别 10: 国家
            // 缩放级别 12: 大城市或州
            // 缩放级别 15: 城市或县
            // 缩放级别 17: 街道
            // 缩放级别 19: 建筑物
            let point = wgs84ToGcj02(lon, lat);
            _this.map.setView([point[1], point[0]], 10);
          },
          function (error) {
            // 错误回调
            // console.log("Chrome只允许HTTPS站点请求地理位置信息");
            console.error("Error finding location:", error);
          }
        );
      } else {
        // 浏览器不支持Geolocation
        alert("Your browser doesn't support geolocation.");
      }
    },
    //获取当前航点并定位
    getCurrentStatus() {
      this.getRequest("/uav-task-server/point/getLastPoint").then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data;
          if (records && records.length > 0) {
            //中心点重定位到首个航点
            let point = wgs84ToGcj02(records[0].longitude, records[0].latitude);
            this.map.setView([point[1], point[0]], 11);
          }
        }
      });
    },
    //监听最新航点以及航线变动，重新绘制航线
    againPlaneWay() {
      this.getRequest("/uav-task-server/point/getLastPoint").then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data;
          if (records && records.length > 0) {
            //中心点重定位到首个航点
            // this.map.setView([records[0].latitude, records[0].longitude], 12);
            //获取所有航道数据绘制航道

            if (this.runLineMarkers.length > 0) {
              this.runLineMarkers.forEach(marker => {
                this.map.removeLayer(marker);
              });
              this.runLineMarkers = [];
            }
            if (this.runLines.length > 0) {
              this.runLines.forEach(runLine => {
                this.map.removeLayer(runLine);
              });
              this.runLines = [];
            }
            if (this.runRoadWhites.length > 0) {
              this.runRoadWhites.forEach(runLine => {
                this.map.removeLayer(runLine);
              });
              this.runRoadWhites = [];
            }

            let runLineMarkers = [];
            records.forEach(item => {
              if (item.wplist) {
                console.log("再次渲染航道");
                let planepoints = [];
                item.wplist.forEach((po, index) => {
                  let point = wgs84ToGcj02(po.wplongitude, po.wplatitude);
                  planepoints.push([point[1], point[0]]);
                  //设置图标样式
                  let myIcon = L.icon({
                    iconUrl: `../../../static/${
                      index == 0 || index == item.wplist.length - 1
                        ? "landPoint"
                        : "normalPoint"
                    }.png`,
                    iconSize:
                      index == 0 || index == item.wplist.length - 1
                        ? [45, 45]
                        : [20, 20]
                  });
                  let markerPoint = L.marker([point[1], point[0]], {
                    icon: myIcon
                  }).addTo(this.map);
                  markerPoint.bindTooltip(
                    `<span style="color:#000;font-weight:bold;">${po.name}</span>`,
                    {
                      //内容可以自定义为HTML，如：<div>自定义结构</div>
                      direction: "bottom", // 显示在底部
                      sticky: false,
                      offset: [0, 0] // 中心位置
                    }
                  );
                  markerPoint.setZIndexOffset(1000);
                  runLineMarkers.push(markerPoint);
                });

                this.planeWay(planepoints, [], item.routeType, "run");
              }
            });
            this.runLineMarkers = runLineMarkers;
          }
        }
      });
    },
    getLastStatus(v) {
      // this.getBounds(); //获取地图边界
      // 创建 WebSocket 连接
      // this.ws = new WebSocket(`ws://192.168.205.102:8769/websocket/playback/${v}`); //内网102
      // this.ws = new WebSocket(`ws://192.168.205.105:8769/websocket/playback/${v}`); //内网105
      // this.ws = new WebSocket(`ws://183.250.235.214:9600/websocket/login/${randomStr}`); //外网106
      this.ws = new WebSocket(`ws://${location.hostname}:9600/websocket/playback/${v}`); //线上 打包使用
      // this.ws = new WebSocket(`ws://220.248.31.148:9600/websocket/playback/${v}`); //线上上海 正式
      // this.ws = new WebSocket(`ws://220.248.31.146:9600/websocket/playback/${v}`); //线上上海 测试
      this.ws.addEventListener('open', () => {
        this.$nextTick(() => {
          this.filterPlane();
        })
        console.log('ws连接成功');
        // 建立连接成功后发送token给后端
        // let token = sessionStorage.getItem('tokenId');
        // this.ws.send('Authorization: Bearer ' + token);
        // 发送屏幕对角线数据给后端
        // this.sendBounds();
      });
      this.ws.addEventListener('close', (e) => {
        console.log('ws连接关闭', e);
        // 连接断开后停止预测点的定时器
        if (window.predictionTimer) {
          clearInterval(window.predictionTimer);
          window.predictionTimer = null;
        }
      });
      this.ws.addEventListener('error', (err) => {
        console.log('ws连接错误', err);
      });
      this.ws.addEventListener('message', (e) => {
        let data = JSON.parse(e.data);
        let records = data.content;
        //1返回为飞机号数组，2为飞机具体数据 10为错误
        if (data.type === 1) {
          this.planeData = records
        } else if (data.type === 2) {
          this.timeStr = records.timebar || '0:00/00:00'
          this.timeProgress = records.percentage
          records = records.point
          this.clickPlaneId ? this.clickPlaneInfo = records.filter(v => v.uasID === this.clickPlaneId)[0] : ''
          if (records && records.length > 0) {
            // console.log("拿到真实数据")
            // 拿到数据后清除预测点的定时器
            if (window.predictionTimer) {
              clearInterval(window.predictionTimer);
              window.predictionTimer = null;
            }

            // console.log('接收到的飞机数据', records, new Date().getTime())

            let uavSerialsArray = records.map(item => ({
              id: item.uasID,
              uasID: item.uasID,
            }));
            this.uavSerials = uavSerialsArray; //搜飞机的
            let infoArr = [];
            let orderID = [];
            let realTask = [];
            records.forEach(po => {
              let info = {};
              info = {
                id: po.orderID,
                longtitude: po.longitude,
                latitude: po.latitude,
                altitude: po.altitude,
                planNo: po.orderID,
                modelName: po.uasModel,
                gs: po.gs,
                course: po.course,
                uasID: po.uasID,
                uavModel: po.uavModel,
                alarm: po.alarm,
                warning: po.warning,
                black: po.black,
                height: po.height,
                uavType: po.uavType,
                routeType: po.routeType,
              };
              if (po.warning || po.alarm) {
                let warnMes = `${po.uasID}在${po.routeName}上发生偏航${
                  po.warning ? "预警" : "告警"
                }`;
                realTask.push({
                  warnMes: warnMes,
                  warning: po.warning,
                  alarm: po.alarm,
                  uasID: po.uasID
                });
              }
              if (po.black) {
                let warnMes = `${po.uasID}正在黑飞告警`;
                realTask.push({
                  warnMes: warnMes,
                  warning: 0,
                  alarm: 1,
                  uasID: po.uasID
                });
              }
              orderID.push(po.orderID);
              infoArr.push(info);
              // 把新接收点信息加入航迹点信息数组
              if (this.singleLine.length > 0 && po.uasID === this.uasId) {
                // this.singleLine =[]
                const lastPoint = this.singleLine[this.singleLine.length - 1];
                if (lastPoint.longitude !== po.longitude || lastPoint.latitude !== po.latitude && lastPoint.uasID === po.uasID && lastPoint.send == 0) {
                  setTimeout(()=>{
                    this.singleLine.push({
                      ...po,
                    });
                  },2000/this.speed)
                  // console.log('加入点', lastPoint.send,this.singleLine);
                } else {
                  // console.log('和最后一个点重复，不加入', this.singleLine)
                }
              }
            });
            this.oldOrderId = orderID;
            this.infoArr = infoArr;
            this.realTask = realTask;
            if (this.infoArr.length > 0) {
              // 画点画航迹
              this.addPointAndLine();
              if (this.singleLine.length > 0 && this.uasId && !this.active1) {
                setTimeout(()=>{
                  this.drawPolylineFromSingleLine(this.uasId);
                },2000/this.speed)

              }
            }
          } else {
            this.uavSerials = [];
            this.realTask = [];
            //清空航点
            if (this.markerPoints.length > 0) {
              this.markerPoints.forEach(marker => {
                this.map.removeLayer(marker);
              });
              this.markerPoints = [];
            }
            //清除航线
            // if (this.polyline) {
            //   this.map.removeLayer(this.polyline);
            //   this.polyline = null;
            // }
            if (this.runlineWhite) {
              this.map.removeLayer(this.runlineWhite);
              this.runlineWhite = null;
            }
            if (this.trackLines.length > 0) {
              this.trackLines.forEach(item => {
                this.map.removeLayer(item);
              });
              this.trackLines = [];
            }
            //清除定位航线
            if (this.positionLines) {
              this.map.removeLayer(this.positionLines);
              this.positionLines = null;
            }
            if (this.positRoadWhite) {
              this.map.removeLayer(this.positRoadWhite);
              this.positRoadWhite = null;
            }
            if (this.airLinePositions.length > 0) {
              this.airLinePositions.forEach(airPort => {
                this.map.removeLayer(airPort);
              });
              this.airLinePositions = [];
            }
            //清除正在飞行的航线以及航点
            if (this.runLineMarkers.length > 0) {
              this.runLineMarkers.forEach(airPort => {
                this.map.removeLayer(airPort);
              });
              this.runLineMarkers = [];
            }
            if (this.runLines.length > 0) {
              this.runLines.forEach(planline => {
                this.map.removeLayer(planline);
              });
              this.runLines = [];
            }
            if (this.runRoadWhites.length > 0) {
              this.runRoadWhites.forEach(runLine => {
                this.map.removeLayer(runLine);
              });
              this.runRoadWhites = [];
            }

            if (this.allPolyline.length > 0) {
              this.allPolyline.forEach(planline => {
                this.map.removeLayer(planline);
              });
              this.allPolyline = [];
            }
            if (this.allPolylines.length > 0) {
              this.allPolylines.forEach(planline => {
                this.map.removeLayer(planline);
              });
              this.allPolylines = [];
            }
          }
          // 获取到真实点后启动定时器进行预测
          if (this.infoArr && this.infoArr.length > 0) {
            // console.log('启动定时器预测',  new Date().getTime())
            //       window.predictionTimer = setInterval(this.predictPoint, 200);
          }
        } else {
          this.$message.error({
            message: data.content,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      });
    },
    // 计算预测点
    // lat1: 起始纬度 lon1: 起始经度 speedMps:速度（米每秒） heading: 航向角（度） timeSec: 时间（秒）
    calculateNewPosition(lat1, lon1, speedMps, heading, timeSec) {
      const EARTH_RADIUS_M = 6371000; // 地球半径（米）
      const distanceM = speedMps * timeSec; // 计算距离（米）

      const headingRadians = this.toRadians(heading);
      const lat1Radians = this.toRadians(lat1);
      const lon1Radians = this.toRadians(lon1);
      const lat2 = Math.asin(Math.sin(lat1Radians) * Math.cos(distanceM / EARTH_RADIUS_M) +
        Math.cos(lat1Radians) * Math.sin(distanceM / EARTH_RADIUS_M) * Math.cos(headingRadians));
      let lon2 = lon1Radians + Math.atan2(Math.sin(headingRadians) * Math.sin(distanceM / EARTH_RADIUS_M) * Math.cos(lat1Radians),
        Math.cos(distanceM / EARTH_RADIUS_M) - Math.sin(lat1Radians) * Math.sin(lat2));
      const lat2Degrees = this.toDegrees(lat2);
      let lon2Degrees = this.toDegrees(lon2);
      lon2Degrees = (lon2Degrees + 180) % 360 - 180;
      return [lat2Degrees, lon2Degrees];
    },
    toDegrees(radians) {
      return radians * (180 / Math.PI);
    },
    toRadians(degrees) {
      return degrees * (Math.PI / 180);
    },

    // 预测点
    predictPoint() {
      // console.log('预测中。。。',  new Date().getTime())
      let newInfoArr = [];
      this.infoArr.forEach(info => {
        //send：1-该点已经接受过；0-该点为新点
        if (info.gs > 0 && info.altitude > 50) {
          let point = this.calculateNewPosition(info.latitude, info.longtitude, info.gs, info.course, 0.15)
          const predictionLat = point[0];
          const predictionLng = point[1];

          newInfoArr.push({
            ...info,
            latitude: predictionLat,
            longtitude: predictionLng,
            isPrediction: true,
          });
          // console.log('预测点-->', point, new Date().getTime())
        } else {
          newInfoArr.push(info);
        }
        if (this.uasId !== info.uasID) {
          //开启实时更新航线
          this.openPopup = true;
          this.uasId = info.uasID;
          // this.addPolyline(this.uasId); // 点击后请求后端接口绘制航迹
          //获取飞机详情速度高度曲线数据
          this.clickPlaneId = info.uasID
          this.clickPlane = info.uasID

        } else if (this.uasId === info.uasID) {
          this.deletePolyAllline();
          this.uasId = null;
        }
      });
      this.infoArr = newInfoArr;
      // console.log('预测点集合newInfoArr', newInfoArr)
      // 画点画航迹
      this.addPointAndLine();
    },

    // 画点画航迹
    async addPointAndLine() {
      // if (this.markerPointData) {
      //   this.markerPointData.forEach(item => {
      //     this.map.removeLayer(item.markerPoint);
      //   });
      //   this.markerPointData = [];
      // }

      // addMarker、updateMarker、deleteMarker
      //绘制所有点
      this.addMarker();
      //绘制点加到地图之后画航迹保证轨迹在后
      setTimeout(() => {
        if (this.active1) {
          this.addPolyAllline();
        }
      })
    },

    queryPlan() {
      this.getRequest(
        `/uav-task-server/plandto/queryPlanDtoByCondition?currentpage=1&pagesize=500&status=10&status=11&status=12&keyWord=${this.searchKey3}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data.list;
          if (records && records.length > 0) {
            let simpleArray = records.map(item => ({
              id: item.id,
              planSerial: item.planSerial,
              uavSerial: item.uavSerial,
              uavModel: item.uavModel,
              pilot: item.pilot,
              type: item.type,
              airpointList: item.airpointList
            }));
            this.runTask = simpleArray;
          } else {
            this.runTask = [];
          }
        } else {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            },
          });
        }
      });
      this.getRequest(
        `/uav-task-server/plandto/queryPlanDtoByCondition?currentpage=1&pagesize=500&status=0&status=1&status=2&status=3&status=4&status=5&status=6&status=7&status=8&status=9&keyWord=${this.searchKey2}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data.list;
          if (records && records.length > 0) {
            let simpleArray = records.map(item => ({
              id: item.id,
              planSerial: item.planSerial,
              uavSerial: item.uavSerial,
              uavModel: item.uavModel,
              pilot: item.pilot,
              type: item.type,
              airpointList: item.airpointList
            }));
            this.preTask = simpleArray;
          } else {
            this.preTask = [];
          }
        } else {
          this.$message.error({
            message: "网络请求失败",
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            },
          });
        }
      });
    },
    //画点

    addMarker(type) {
      //清除之前的包络
      // if (this.oldEllipse.length) {
      //   this.oldEllipse.map(v => {
      //     this.map.removeLayer(v);
      //   })
      //   this.oldEllipse = []
      // }
      if (this.markerPoints.length === 0) {
        this.infoArr.forEach(info => {
          this.createMarker(info, type);
        });
        // console.log(this.markerPointData,'yu');
      } else {
        const oldUasIds = this.markerPointData.map(data => data.info.uasID);
        const newUasIds = this.infoArr.map(info => info.uasID);
        // 找出新增的 info
        const newInfos = this.infoArr.filter(info => !oldUasIds.includes(info.uasID));
        // 找出相同的 info
        const sameInfos = this.infoArr.filter(info => oldUasIds.includes(info.uasID));

        // 找出多余的 info
        const redundantInfos = this.markerPointData.filter(data => !newUasIds.includes(data.info.uasID));
        redundantInfos.forEach(data => {
          this.map.removeLayer(data.markerPoint);
          const index = this.markerPoints.indexOf(data.markerPoint);
          if (index !== -1) {
            this.markerPoints.splice(index, 1);
            this.markerPointData.splice(index, 1);
          }
        });
        // 为新增的 info 添加标记点
        newInfos.forEach(info => {
          this.createMarker(info, type);
        });

        function lerp(start, end, t) {
          return [
            start[1] + (end[1] - start[1]) * t, // 纬度
            start[0] + (end[0] - start[0]) * t  // 经度
          ];
        }

        function animateMarker(marker, oldPoint, newPoint, duration) {
          let startTime = null;

          function animate(currentTime) {
            if (!startTime) startTime = currentTime;
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1); // 进度（0 到 1）
            // 计算当前点位置
            const currentPoint = lerp(oldPoint, newPoint, progress);
            marker.setLatLng(currentPoint);
            // 如果动画未完成，继续下一帧
            if (progress < 1) {
              requestAnimationFrame(animate);
            }
          }

          requestAnimationFrame(animate);
        }

        // 让相同的 info 对应的标记点平滑移动
        sameInfos.forEach(info => {
          if (this.markerPointData.length) {
            const index = oldUasIds.indexOf(info.uasID);
            if (!this.markerPointData[index]) {
              return;
            }
            const markerPoint = this.markerPointData[index].markerPoint;
            const oldInfo = this.markerPointData[index].info;
            if (oldInfo.longtitude === info.longtitude && oldInfo.latitude === info.latitude) {
              return;
            }
            // 获取旧点和新点
            let oldPoint = wgs84ToGcj02(oldInfo.longtitude, oldInfo.latitude);
            let newPoint = wgs84ToGcj02(info.longtitude, info.latitude);
            // 调用动画函数，设置动画持续时间为 1 秒
            animateMarker(markerPoint, oldPoint, newPoint, 2000 / this.speed);
            // 更新图标和提示信息
            let iconUrl = this.getIconUrl(info);
            let iconSize = this.typeMap[info.uavType]                                // 其他情况返回 30
            //设置图标样式
            let newIcon = L.divIcon({
              html: `<div id="planeMarker" class="planeMarker ${!this.isEnvelope ? 'planeMarkerActive' : ''} "  ><img src=${iconUrl} alt=" " class="${this.typeMarkerSizeMap[info.uavType]
                }"></div>`,
              className: "planeMarker", // 添加我们定义的CSS类
              // iconSize: 40
              iconSize: [iconSize, iconSize],
              iconAnchor: [iconSize / 2, iconSize / 2]
            });
            let point = wgs84ToGcj02(info.longtitude, info.latitude);
            let rotateAngle = info.course; //航迹角 正北方向为0度，顺时针旋转
            markerPoint.setIcon(newIcon);
            markerPoint.setRotationAngle(rotateAngle);

            // 更新提示信息
            const planNoContent = info.planNo ? `<span>${info.planNo}</span>` : `<span>无计划</span>`;
            const alarmDiv = this.getAlarmDiv(info);
            const altitude = info.altitude != null ? Number(info.altitude).toFixed(2) + " m" : "/";
            const gs = info.gs != null ? Number(info.gs).toFixed(2) + " m/s" : "/";
            const height = info.height != null ? Number(info.height).toFixed(2) + " m" : "/";
            const course = info.course != null ? info.course + " °" : "/";
            const toolTip = this.isSimplifyTooltip ? `
                  <div class="content">
                      <div class='tag' >
                          <div  style="overflow:hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 100%;">${info.uasID != null ? info.uasID : "/"}</div>
                          <div >${info.modelName || info.uavModel || '/'}</div>
                          <div>${altitude}</div>
                          <div>${gs}</div>
                      </div>
                  </div>` : `
                  <div class="content">
                      <div class="title" style="margin-left: 8px;overflow: hidden;width:200px;text-overflow: ellipsis;white-space: nowrap;">${info.uasID != null ? info.uasID : "/"}</div>
                      <div class='tag'>
                          <div >计划编号:${planNoContent}</div>
                          <div >飞机型号:${info.modelName || info.uavModel || '/'}</div>
                          <div >经度:<span>${info.longtitude != null ? this.decimalToDMS(info.longtitude) : "/"}</span></div>
                          <div >纬度:<span>${info.latitude != null ? this.decimalToDMS(info.latitude) : "/"}</span></div>
                          <div >海拔高:<span>${altitude}</span></div>
                          <div >真高:<span>${height}</span></div>
                          <div>速度:<span>${gs}</span></div>
                          <div >航迹角:<span>${course}</span></div>
                          ${alarmDiv}
                      </div>
                  </div>`;

            markerPoint.bindTooltip(toolTip, {
              autoPan: false,
              zIndexOffset: 1100,
              direction: "bottom",
              permanent: this.tooltipPermanent || this.clickPlane === info.uasID,
              offset: [0, iconSize / 2],
              className: this.isSimplifyTooltip ? 'simplifyTooltip' : "anim-tooltip"
            });

            const iconElement = markerPoint.getElement();
            if (info.alarm || info.warning || info.black) {
              iconElement && iconElement.classList.add("blinking");
            } else {
              iconElement && iconElement.classList.remove("blinking");
            }
            // 更新 markerPointData 中的 info
            this.markerPointData[index].info = info;
          }
        });
      }
    },
    //展示标牌
    changeSign(flag) {
      if(flag){
        // 切换工具提示的 permanent 状态
        this.tooltipPermanent = true;
      }else {
        this.tooltipPermanent = false;
        this.clickPlane = null
      }
      this.markerPointData.map(item => {
        let info = item.info
        const planNoContent = info.planNo ? `<span>${info.planNo}</span>` : `<span>无计划</span>`;
        //高度、速度、航迹角
        let altitude =
          info.altitude != null ? Number(info.altitude).toFixed(2) + " m" : "/";
        let gs = info.gs != null ? Number(info.gs).toFixed(2) + " m/s" : "/";
        let height = info.height != null ? Number(info.height).toFixed(2) + " m" : "/";
        let course = info.course != null ? info.course + " °" : "/";
        this.isSimplifyTooltip ? this.toolTip = `
        <div class="content">
        <div class='tag' >
                <div  style="overflow:hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 100%;">${info.uasID != null ? info.uasID : "/"}</div>
              <div >${info.modelName || info.uavModel || '/'}</div>
              <div>${altitude}</div>
              <div>${gs}</div>
          </div>
        </div>` :
          this.toolTip = `
        <div class="content">
          <div class="title" style="margin-left: 8px;overflow: hidden;width:200px;text-overflow: ellipsis;white-space: nowrap;">${info.uasID != null ? info.uasID : "/"}</div>
          <div class='tag'>
              <div >计划编号:${planNoContent}</div>
              <div >飞机型号:${info.modelName || info.uavModel || '/'}</div>
              <div >经度:<span>${info.longtitude != null
            ? this.decimalToDMS(info.longtitude)
            : "/"
          }</span>
              </div>
              <div >纬度:<span>${info.latitude != null ? this.decimalToDMS(info.latitude) : "/"
          }</span>
              </div>
              <div >海拔高:<span>${altitude}</span></div>
              <div >真高:<span>${height}</span></div>
              <div>速度:<span>${gs}</span></div>
              <div >航迹角:<span>${course}</span></div>
            ${this.getAlarmDiv(info)}
          </div>
        </div>`;


        //更新标牌
        item.markerPoint.bindTooltip(this.toolTip, {
          //内容可以自定义为HTML，如：<div>自定义结构</div>
          autoPan: false,
          zIndexOffset: 1100,
          direction: "bottom", // 显示在底部
          permanent: this.tooltipPermanent || this.clickPlane === info.uasID, // 永久打开提示
          offset: [0, 15], // 向下偏移
          className: this.isSimplifyTooltip ? 'simplifyTooltip' : "anim-tooltip" // 自定义class
        });
      })
    },

    //绘制所有计划航道
    planeAllWay() {
      //分页查询所有航线，cairline/queryAllCAirline?currentpage=1&pagesize=100
      this.getRequest(
        "/uav-task-server/cairline/queryAllCAirline?pagesize=500&currentpage=1"
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let list = oData.data.list;
          if (list && list.length > 0) {
            if (this.planLines.length > 0) {
              this.planLines.forEach(planline => {
                this.map.removeLayer(planline);
              });
              this.planLines = [];
            }
            if (this.planlineWhite.length > 0) {
              this.planlineWhite.forEach(v => {
                this.map.removeLayer(v);
              });
              this.planlineWhite = [];
            }
            let disableIds = []
            if (this.tableData.length) {
              disableIds = this.tableData.filter(v => v.isShowLine === false).map(e => (e.id))
              if (disableIds.length) {
                this.showlineall = false
              } else {
                this.showlineall = true
              }
            } else {
              this.tableData = list.map(v => ({
                name: v.name,
                updatedAt: v.updatedAt,
                // updatedAt: v.updatedAt.splice(0, 3).join('-') + ' ' + v.updatedAt.splice(-3).map(e => ((e + '').padStart(2, '0'))).join(':'),
                isShowLine: true,
                id: v.id
              }))
            }
            list.forEach(airLine => {
              if (disableIds.includes(airLine.id)) {
                return
              }
              let airLineData = [];
              let points = [];
              airLine.airpointList.forEach(airpoint => {
                let point = wgs84ToGcj02(airpoint.longitude, airpoint.latitude);
                airLineData.push([point[1], point[0]]);
                points.push({
                  po: [point[1], point[0]],
                  name: airpoint.name,
                  altitude: airpoint.altitude,
                  type: airpoint.type
                });
              });
              this.planeWay(airLineData, points, airLine.airLineType, "plan", airLine.altitude, airLine.name,airLine.configdence?JSON.parse(airLine.configdence).weightedScore:'');
            });
          }
        } else {
          this.$message.error({
            message: "网络请求失败",
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            },
          });
        }
      });
    },
    //绘制航道
    planeWay(wayPoints, points, wayType, type, altitude, name,weightedScore) {
      const _this = this
      // let weight = 8;
      // if (this.currentZoom < 10) {
      //   weight = 4;
      // } else if (this.currentZoom >= 10 && this.currentZoom <= 12) {
      //   weight = 8;
      // } else {
      //   weight = 12;
      // }
      // 0：观光 1：巡检 2：物流
      let waycolor =
        wayType == 1
          ? "#b5b500"
          : wayType == 0
            ? "#008000"
            : wayType == 2
              ? "#0000ff" : wayType == 3 ? '#fd5939' : "#0000ff";
      // if (!wayType) {
      //   waycolor = "#0000ff";
      // }
      if (this.positionLines) {
        this.map.removeLayer(this.positionLines);
        this.positionLines = null;
      }
      if (this.positRoadWhite) {
        this.map.removeLayer(this.positRoadWhite);
        this.positRoadWhite = null;
      }

      //绘制航线上的斜线
      let planlineWhite = null
      // 创建一个折线
      if (this.showDubuleLine) {
        planlineWhite = L.polyline(wayPoints, {
          smoothFactor: 1,
          color: "#fff", //航道底部颜色
          opacity: 0.8,
          weight: 9, //航道底部宽度
          lineCap: "butt",
          lineJoin: "round" // 线条连接处样式
        }).addTo(this.map);
      }

      function togglePopup(latlng, showPopup, map) {
        let popup;
        if (showPopup) {
          popup = L.popup({
            closeButton: false // 设置closeButton为false来隐藏关闭按钮
          })
            .setLatLng(latlng)
            .setContent(`<span style="color:#000;font-weight:bold;">${name}(${altitude}m)</span>`)
            .openOn(map);
        } else {
          popup && popup.close()

        }
      }

      // 添加 hover 事件监听器 航线移入移出
      // if (planlineWhite) {
      //   planlineWhite.on('mouseover', function (e) {
      //     //这里this指向map
      //     togglePopup(e.latlng, true, _this.map);
      //   });
      //   planlineWhite.on('mouseout', function (e) {
      //     togglePopup(e.latlng, false, _this.map, e);
      //   });
      // }


      let planline = L.polyline(wayPoints, {
        smoothFactor: 1,
        color: waycolor, //航道颜色
        opacity: 0.8,
        weight: this.showDubuleLine ? 5 : 2, //航道宽度
        lineCap: "butt",
        lineJoin: "round", // 线条拐角样式
        dashArray: this.showDubuleLine ? "10,2" : null, // 虚线，例如'10,10'表示10像素的实线和10像素的空白交替出现
        dashOffset: "1", // 虚线偏移量
        zIndex: 10 // 设置折线的 zIndex 属性
      }).addTo(this.map);
      planline.bindTooltip(name+ (weightedScore?`(${weightedScore})`:''), {
        autoPan: false,
        zIndexOffset: 1100,
        direction: "auto",
       permanent: this.showAirLineName?true:false,
        className: 'planlineName'
      });
      planline.on('mouseover', function (e) {
        //这里this指向map
        togglePopup(e.latlng, true, _this.map);
      });
      planline.on('mouseout', function (e) {
        togglePopup(e.latlng, false, _this.map, e);
      });
      if (planlineWhite) {
        planline.on('mouseover', function (e) {
          //这里this指向map
          togglePopup(e.latlng, true, _this.map);
        });
        planline.on('mouseout', function (e) {
          togglePopup(e.latlng, false, _this.map, e);
        });
      }
      this.drawAirLinePorts(points, type);
      if (type == "plan") {
        if (planlineWhite) {
          this.planlineWhite.push(planlineWhite);
        }
        this.planLines.push(planline);
      } else if (type == "run") {
        this.runLines.push(planline);
        if (planlineWhite) {
          this.runRoadWhites.push(planlineWhite);
        }
      } else if (type == "position") {
        this.positionLines = planline;
        if (planlineWhite) {
          this.positRoadWhite = planlineWhite;
        }
      }
    },
    //绘制航道上的航点
    drawAirLinePorts(pointData, type) {
      if (!this.showNormalairPort) {
        pointData = pointData.filter(v => (v.type !== 0))
      }
      if (!this.showairPort) {
        pointData = pointData.filter(v => {
          return v.type !== 1 && v.type !== 2
        })
      }
      if (this.airLinePositions.length > 0) {
        this.airLinePositions.forEach(marker => {
          this.map.removeLayer(marker);
        });
        this.airLinePositions = [];
      }
      if (pointData.length > 0) {
        pointData.forEach((item, index) => {
          //设置图标样式
          let myIcon = L.icon({
            iconUrl: `../../../static/${index == 0 || index == pointData.length - 1 || item.type === 1 || item.type === 2
              ? "landPoint"
              : "normalPoint"
            }.png`,
            iconSize:
              index == 0 || index == pointData.length - 1 || item.type === 1 || item.type === 2 ? [45, 45] : [20, 20]
          });
          let markerPoint = L.marker(item.po, {
            icon: myIcon
          }).addTo(this.map);
          // 将 markerToTop 提升
          markerPoint.setZIndexOffset(1000);
          markerPoint.bindTooltip(
            `<span style="color:#000;font-weight:bold;">${item.name + '(' + item.altitude + 'm)'}</span>`,
            {
              //内容可以自定义为HTML，如：<div>自定义结构</div>
              direction: "bottom", // 显示在底部
              sticky: false,
              offset: [0, 0], // 中心位置
              className: 'isSimplifyTooltip11'
            }
          );
          if (type == "position") {
            this.airLinePositions.push(markerPoint);
          } else {
            this.airLinePorts.push(markerPoint);

          }
        });
        // this.airLinePorts = airLinePorts;
      }
    },
    //绘制单条航迹
    addPolyline(uasId) {
      // 清理之前的航迹
      this.getRequest(`/uav-task-server/playback/getTrack?uasID=${uasId}&websocketId=${this.websocketId}`).then(
        res => {
          // setTimeout(()=>{
          //   this.deletePolyAllline();
          // },2000/this.speed)
          let data = res.data.data;
          this.singleLine = data;
          this.drawPolylineFromSingleLine(uasId)
        }
      );
    },
    drawPolylineFromSingleLine(uasId) {
      // 每个航点的航迹点
      let points = [];
      let waycolor = "";
      if (this.singleLine.length > 0) {
        let routeType = this.singleLine[0].routeType;
        // 0：观光 1：巡检 2：物流 2：应急
        waycolor =
          routeType === 1
            ? "#b5b500"
            : routeType === 0 ? "#008000"
              : routeType === 2 ? "#0000ff"
                : routeType === 3 ? "#fd5939" : "#0000ff";

        this.singleLine.forEach(item => {
          let point = wgs84ToGcj02(item.longitude, item.latitude);
          points.push([point[1], point[0]]);
        });
        const firstPoints = points.slice(0, points.length - 1);
        let flag = false; // 判断是否停止了
        if (this.lineLength.hasOwnProperty(uasId)) {
          if (this.lineLength[uasId] === this.singleLine.length) {
            flag = true;
          } else {
            this.lineLength = {};
            this.lineLength[uasId] = this.singleLine.length;
          }
        } else {
          this.lineLength[uasId] = this.singleLine.length;
        }
        // 绘制背景线条
        let runlineWhite = L.polyline(flag ? points : firstPoints, {
          smoothFactor: 1,
          color: "#fff",
          weight: 5,
          lineCap: "butt",
          lineJoin: "round"
        }).addTo(this.map);
        let trackLine = L.polyline(flag ? points : firstPoints, {
          smoothFactor: 1,
          color: waycolor, //#FF9C00橙色
          weight: 3,
          lineCap: "butt",
          lineJoin: "round" // 线条拐角样式
        }).addTo(this.map);

        // 添加到数组
        this.trackLines.push(trackLine);
        this.runlineWhites.push(runlineWhite);
        // 最后一个点
        const lastPoint = points[points.length - 1];
        const totalTime = 2000 / this.speed; // 总时间 2 秒/倍速
        const steps = 10;
        const interval = totalTime / steps;
        let currentStep = 0;
        const startPoint = firstPoints[firstPoints.length - 1];
        let deltaLat
        let deltaLng
        if(startPoint&&startPoint.length){
          deltaLat = (lastPoint[0] - startPoint[0]) / steps;
          deltaLng = (lastPoint[1] - startPoint[1]) / steps;
        }
        const drawNextStep = () => {
          if (currentStep < steps) {
            const newLat = startPoint[0] + deltaLat * (currentStep + 1);
            const newLng = startPoint[1] + deltaLng * (currentStep + 1);
            const newPoint = [newLat, newLng];
            const currentPoints = trackLine.getLatLngs();
            currentPoints.push(newPoint);
            trackLine.setLatLngs(currentPoints);
            runlineWhite.setLatLngs(currentPoints);
            currentStep++;
            setTimeout(drawNextStep, interval);
          }
        };
        if (!flag && startPoint) {
          drawNextStep();
        }
      }
    },
    clearAllLine() {
      if (this.allPolyline.length > 0) {
        this.allPolyline.forEach(el => {
          this.map.removeLayer(el);
        });
        this.allPolyline = [];
      }
      if (this.allPolylines.length > 0) {
        this.allPolylines.forEach(el => {
          this.map.removeLayer(el);
        });
        this.allPolylines = [];
      }
    },
    //绘制所有航迹
    addPolyAllline() {
      this.getRequest("/uav-task-server/playback/getAllTrack?websocketId=" + this.websocketId).then(res => {
        this.clearAllLine()
        let data = res.data.data;
        //第一和第二次接口返回的是{} 和null
        if (!data) {
          return
        }
        if (Object.keys(data).length) { //判断是否有航迹
          //每个航点的航迹
          let waycolor = "";
          for (let key in data) {
            // if (key == "track:" + item.uasID) {
            // }
            let flag = true //判断是否停止了或者没有更新数据
            if (Object.keys(this.allLineLength).includes(key)) {
              if (this.allLineLength[key] === data[key].length) {
                flag = false
              } else {
                this.allLineLength[key] = data[key].length
              }
            } else {
              this.allLineLength[key] = data[key].length
            }
            let points = [];
            if (data[key].length > 0) {
              data[key].forEach(item => {
                let point = wgs84ToGcj02(item.longitude, item.latitude);
                points.push([point[1], point[0]]);
              });
            }
            let routeType = data[key][0].routeType;
            // 0：观光 1：巡检 2：物流
            waycolor =
              routeType == 1
                ? "#b5b500"
                : routeType == 0
                  ? "#008000"
                  : routeType == 2
                    ? "#0000ff"
                    : routeType == 3
                      ? '#fd5939'
                      : "#0000ff";
            const firstPoints = points.slice(0, points.length - 1)
            if (this.active1) {
              let runlineWhite
              let polyline
              if (flag) {
                runlineWhite = L.polyline(firstPoints, {
                  smoothFactor: 1,
                  color: "#fff", //航道颜色
                  weight: 5, //航道宽度
                  lineCap: "butt",
                  lineJoin: "round" // 线条拐角样式
                }).addTo(this.map);
                polyline = L.polyline(firstPoints, {
                  smoothFactor: 1,
                  color: waycolor, //#FF9C00橙色
                  weight: 3,
                  lineCap: "butt",
                  lineJoin: "round" // 线条拐角样式
                }).addTo(this.map);
              }

              // 最后一个点
              const lastPoint = points[points.length - 1];
              const totalTime = 2000 / this.speed;
              const steps = 10; // 分割成 10 个小步骤
              const interval = totalTime / steps;

              let currentStep = 0;
              const startPoint = firstPoints[firstPoints.length - 1];
              let deltaLat
              let deltaLng
              if (startPoint&&startPoint.length) {
                deltaLat = (lastPoint[0] - startPoint[0]) / steps;
                deltaLng = (lastPoint[1] - startPoint[1]) / steps;
              }
              const drawNextStep = () => {
                if (currentStep < steps) {
                  const newLat = startPoint[0] + deltaLat * (currentStep + 1);
                  const newLng = startPoint[1] + deltaLng * (currentStep + 1);
                  const newPoint = [newLat, newLng];
                  const currentPoints = polyline.getLatLngs();
                  currentPoints.push(newPoint);
                  polyline.setLatLngs(currentPoints);
                  runlineWhite.setLatLngs(currentPoints);
                  currentStep++;
                  setTimeout(drawNextStep, interval);
                }
              }
              // 开始绘制最后一个点
              if (flag && !!startPoint && polyline) {
                drawNextStep();
              }
              setTimeout(() => {
                if (flag && polyline) {
                  this.allPolyline.push(polyline);
                  this.allPolylines.push(runlineWhite);
                }
              }, 2000 / this.speed)
            }
          }
        }
      });
    },
    //删除所有航迹
    deletePolyAllline() {
      if (this.trackLines.length > 0) {//单条实线
        this.trackLines.forEach(item => {
          this.map.removeLayer(item);
        });
        this.trackLines = [];
      }
      if (this.runlineWhites.length > 0) {//单条白线
        this.runlineWhites.forEach(item => {
          this.map.removeLayer(item);
        });
        this.runlineWhites = [];
      }
      if (this.allPolyline.length > 0) {
        this.allPolyline.forEach(item => {
          this.map.removeLayer(item);
        });
        this.allPolyline = [];
      }
      if (this.allPolylines.length > 0) {
        this.allPolylines.forEach(item => {
          this.map.removeLayer(item);
        });
        this.allPolylines = [];
      }
      this.allLineLength = {}
      this.lineLength = {}
    },
    //绘制空域
    airSpace() {
      this.getRequest("/uav-task-server/airspace/queryAirspace?cateType=10")
        .then(res => {
          let oData = res.data;
          if (oData.code == 0) {
            let res = JSON.parse(oData.data);
            let features = res.features;
            //绘制前清除空域
            if (this.airSpaces.length > 0) {
              this.airSpaces.forEach(item => {A
                this.map.removeLayer(item);
              });
            }
            //设置颜色分类
            if (features.length > 0) {
              //0 禁飞区 1 电子围栏（有个属性控制，在电子围栏内是否可飞） 2. 3.适飞区 4. 限飞区
              const colorType = ["red", "red", "", "green", "yellow"];
              let airSpaces = [];
              //遍历每一类的空域
              // this.airSpaceTableData = features.map(v=>({
              //   airspaceName:v.properties.airspaceName,
              //   COLOR:v.properties.COLOR==='red'?'红色':'绿色',
              //   NAME:v.properties.NAME,
              //   STARTTIME:v.properties.STARTTIME.slice(0,10),
              //   ENDTIME:v.properties.ENDTIME.slice(0,10)
              // }))
              let disableIds = []
              if (this.airSpaceTableData.length) {
                disableIds = this.airSpaceTableData.filter(v => v.isShowAirSpace === false).map(e => (e.id))
                if (disableIds.length) {
                  this.showAirspaceAll = false
                } else {
                  this.showAirspaceAll = true
                }
              } else {
                this.airSpaceTableData = features.map(v => ({
                  airspaceName: v.properties.airspaceName,
                  COLOR:v.properties.COLOR === 'red'
                    ? '红色'
                    : v.properties.COLOR === 'green'
                      ? '绿色'
                      : v.properties.COLOR === 'yellow'
                        ? '黄色'
                        : v.properties.COLOR === 'orange'
                          ? '橙色'
                          : v.properties.COLOR,
                  TYPE: v.properties.TYPE,
                  STARTTIME: v.properties.STARTTIME.slice(0, 10),
                  ENDTIME: v.properties.ENDTIME.slice(0, 10),
                  isShowAirSpace: true,
                  id: v.properties.id
                }))
              }

              features.forEach(space => {
                if (disableIds.includes(space.properties.id)) {
                  return
                }

                let shapeType = space.properties.SHAPETYPE;
                //遍历该类型下的所有空域多边形
                space.geometry.coordinates.forEach(coordinate => {
                  if (disableIds.includes(coordinate.id)) {
                    return
                  }
                  //转换经纬度为纬经度
                  let changedCoord = [];
                  coordinate[0].forEach(point => {
                    let wgsPoint = wgs84ToGcj02(point[0], point[1]);
                    changedCoord.push([wgsPoint[1], wgsPoint[0]]);
                  });
                  let svgGradient1 = `
                       <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                  <defs>
                      <radialGradient id="redSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           <stop offset="80%" style="stop-color:#ff5555; stop-opacity:0" />
                            <stop offset="100%" style="stop-color:#ff5555;stop-opacity:1" />
                      </radialGradient>
                  </defs>
                       </svg>`;
                  let svgGradient2 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="greenSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                             <stop offset="80%" style="stop-color:#0fd077; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:#0fd077;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;
                  let svgGradient3 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="yellowSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           <stop offset="80%" style="stop-color:#ffc877; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:#ffc877;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;
                  let svgGradient4 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="graySpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           stop offset="80%" style="stop-color:gray; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:gray;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;

                  // 将 SVG 渐变添加到文档
                  document.getElementById('svg-container').insertAdjacentHTML('afterbegin', svgGradient1);
                  document.getElementById('svg-container').insertAdjacentHTML('afterbegin', svgGradient2);
                  document.getElementById('svg-container').insertAdjacentHTML('afterbegin', svgGradient3);
                  document.getElementById('svg-container').insertAdjacentHTML('afterbegin', svgGradient4);
                  let polygon = null;
                  if (shapeType == 0) {
                    //绘制多边形
                    polygon = L.polygon(changedCoord, {
                      color: this.isStyleApplied ? 'rgba(214,211,241,0.48)' :space.properties.TYPE === 0 || space.properties.TYPE === 1
                        ? '#e21838'
                        : space.properties.TYPE === 3
                          ? '#21f48e'
                          : space.properties.TYPE === 4 || space.properties.TYPE === 21
                            ? 'yellow'
                            : space.properties.TYPE === 11
                              ? 'orange'
                              : null, //填充颜色, //边框颜色#aa0000
                      fillColor: this.isStyleApplied ? 'rgba(214,211,241,0.48)' :space.properties.TYPE === 0 || space.properties.TYPE === 1
                        ? 'rgba(226,24,56,0.48)'
                        : space.properties.TYPE === 3
                          ? 'rgba(32,180,67,0.48)'
                          : space.properties.TYPE === 4 || space.properties.TYPE === 21
                            ? 'rgba(252,255,44,0.48)'
                            : space.properties.TYPE === 11
                              ? 'rgba(248,168,34,0.48)'
                              : null, //填充颜色
                      fillOpacity: 1, //填充透明度
                      weight: 1 //边框宽度
                    }).addTo(this.map);
                    polygon.myCustomType = space.properties.TYPE
                  } else {
                    // polygon = L.circle(changedCoord[0], {
                    //   radius: space.properties.RADIUS, // 设置圆的半径
                    //   color: "rgba(0,0,0,0.5)", // 设置圆的边框颜色
                    //   fillColor: colorType[space.properties.TYPE], // 设置圆的填充颜色
                    //   fillOpacity: 0.3, // 设置圆的填充透明度
                    //   weight: 1 //边框宽度
                    // }).addTo(this.map);
                    polygon = L.circle(changedCoord[0], {
                      radius: space.properties.RADIUS, // 设置圆的半径
                      color: this.isStyleApplied ? 'rgba(214,211,241,0.48)' :space.properties.TYPE === 0 || space.properties.TYPE === 1
                        ? '#e21838'
                        : space.properties.TYPE === 3
                          ? '#21f48e'
                          : space.properties.TYPE === 4 || space.properties.TYPE === 21
                            ? 'yellow'
                            : space.properties.TYPE === 11
                              ? 'orange'
                              : null, //填充颜色, //边框颜色#aa0000
                      fillColor: this.isStyleApplied ? 'rgba(214,211,241,0.48)' :space.properties.TYPE === 0 || space.properties.TYPE === 1
                        ? 'rgba(226,24,56,0.48)'
                        : space.properties.TYPE === 3
                          ? 'rgba(32,180,67,0.48)'
                          : space.properties.TYPE === 4 || space.properties.TYPE === 21
                            ? 'rgba(252,255,44,0.48)'
                            : space.properties.TYPE === 11
                              ? 'rgba(248,168,34,0.48)'
                              : null, //填充颜色
                      fillOpacity: 1, //填充透明度
                      weight: 1 //边框宽度
                    }).addTo(this.map);
                    polygon.myCustomType = space.properties.TYPE
                  }

                  //   polygon.bindTooltip(
                  //     `<span style="color:#
                  // 000;font-weight:bold;">${space.properties.airspaceName}</span>`,
                  //     {
                  //       //内容可以自定义为HTML，如：<div>自定义结构</div>
                  //       direction: "bottom", // 显示在底部
                  //       sticky: false,
                  //       offset: [0, 0] // 中心位置
                  //     }
                  //   );
                  let _this = this
                  // 添加 hover 事件监听器 移入移出
                  if (polygon) {
                    let popup;

                    function togglePopup(latlng, showPopup, map) {
                      if (showPopup) {
                        popup = L.popup({
                          closeButton: false // 设置closeButton为false来隐藏关闭按钮
                        })
                          .setLatLng(latlng)
                          .setContent(`
                            <div style="color:#000;font-weight:bold;text-align: center;font-size: 14px">${space.properties.airspaceName}(${space.properties.BOTTOM_HEIHGT}~${space.properties.HEIGHT + space.properties.BOTTOM_HEIHGT}m)</div>
                           <div>${space.properties.STARTTIME} ~ ${space.properties.ENDTIME} </div>
                          `)
                          .openOn(map);
                      } else {
                        popup.close()

                      }
                    }

                    polygon.on('mouseover', function (e) {
                      //这里this指向map
                      togglePopup(e.latlng, true, _this.map);
                    });
                    polygon.on('mouseout', function (e) {
                      togglePopup(e.latlng, false, _this.map, e);
                    });
                  }

                  airSpaces.push(polygon);
                });
              });
              this.airSpaces = airSpaces;
            }
            //将航线 移动到最顶层
            if (this.planlineWhite.length > 0) {
              this.planlineWhite.forEach(planline => {
                planline.removeFrom(this.map);
                planline.addTo(this.map);
              });
            }
            if (this.planLines.length > 0) {
              this.planLines.forEach(planline => {
                planline.removeFrom(this.map);
                planline.addTo(this.map);
              });
            }
          } else {
            console.log(oData.msg);
          }
        });
    },
    //绘制起降点
    airPort() {
      this.getRequest(
        "/uav-task-server/cpoint/queryAllCPoint?pagesize=700&currentpage=1"
      ).then(res => {
        let oData = res.data;
        if (0 == oData.code) {
          let pointDataList = oData.data.list;
          this.drawAirPorts(pointDataList);
        }
      });
    },
    drawAirPorts(pointDataList) {
      let airPorts = [];
      pointDataList.forEach(item => {
        //设置图标样式
        let myIcon = L.icon({
          iconUrl: `../../../static/${
            item.type == 0
              ? "normalPoint"
              : item.type == 1
                ? "landPoint"
                : "landPoint"
          }.png`,
          iconSize: item.type == 0 ? [20, 20] : [45, 45]
        });
        let center = wgs84ToGcj02(item.longitude, item.latitude);
        let markerPoint = L.marker([center[1], center[0]], {
          icon: myIcon
        })
        // .addTo(this.map);
        markerPoint.bindTooltip(
          `<span style="color:#
            000;font-weight:bold;">${item.name}</span>`,
          {
            //内容可以自定义为HTML，如：<div>自定义结构</div>
            direction: "bottom", // 显示在底部
            sticky: false,
            offset: [0, 0] // 中心位置
          }
        );
        airPorts.push(markerPoint);
      });
      this.airPorts = airPorts;
      // 创建聚合标记组
      this.markers = L.markerClusterGroup({
        maxClusterRadius: 10, //设置最大聚类半径
        spiderfyOnMaxZoom: true,
      });
      // 添加聚合标记
      this.markers.addLayers(this.airPorts); //一次性聚合所有航点
      this.map.addLayer(this.markers);
    },
    //清空所有计划航道
    deletePlaneAllWay() {
      if (this.planLines.length > 0) {
        this.planLines.forEach(planline => {
          this.map.removeLayer(planline);
        });
        this.planLines = [];
      }
      if (this.planlineWhite.length > 0) {
        this.planlineWhite.forEach(planline => {
          this.map.removeLayer(planline);
        });
        this.planlineWhite = [];
      }

      if (this.airLinePorts.length > 0) {
        this.airLinePorts.forEach(point => {
          this.map.removeLayer(point);
        });
        this.airLinePorts = [];
      }
    },
    //清空所有空域
    daleteAirSpace() {
      if (this.airSpaces.length > 0) {
        this.airSpaces.forEach(airSpace => {
          this.map.removeLayer(airSpace);
        });
        this.airSpaces = [];
      }
    },
    //清空所有机场
    daleteAirPort() {
      if (this.airPorts.length > 0) {
        this.airPorts.forEach(airPort => {
          this.map.removeLayer(airPort);
        });
        this.airPorts = [];
        this.markers.clearLayers(); //清空聚合标记
      }
      // if (this.runLineMarkers.length > 0) {
      //   this.runLineMarkers.forEach(airPort => {
      //     this.map.removeLayer(airPort);
      //   });
      // }
    },
    //更新航道线宽样式
    updatePolylineWeight() {
      let weight = 10;
      if (this.currentZoom <= 12) {
        weight = 8;
      } else {
        weight = 12;
      }
      if (this.planLines.length > 0) {
        this.planLines.forEach(planline => {
          planline.setStyle({
            weight: weight
          });
        });
      }
      if (this.planlineWhite.length > 0) {
        this.planlineWhite.forEach(planline => {
          planline.setStyle({
            weight: weight + 4
          });
        });
      }
      if (this.runLines.length > 0) {
        this.runLines.forEach(planline => {
          planline.setStyle({
            weight: weight
          });
        });
      }
    },
    //定位飞机或航线
    positionPoint(point) {
      let newpoint = wgs84ToGcj02(point.longitude, point.latitude);
      this.map.setView([newpoint[1], newpoint[0]], 16);
    },

    // 绘制风向箭头的函数
    windLayer(data) {
      var velocityLayer = L.velocityLayer({
        displayValues: true,
        displayOptions: {
          velocityType: "GBR Wind",
          displayPosition: "bottomleft",
          displayEmptyString: "No wind data"
        },
        data: data,
        minVelocity: 0, //Velocity：速率
        maxVelocity: 10,
        velocityScale: 0.005,
        particleMultiplier: 1 / 300, //粒子的数量
        lineWidth: 2, //粒子的粗细
        frameRate: 15, //定义每秒执行的次数
        colorScale: [
          "rgb(255,255,255)",
          "rgb(255,255,255)",
          "rgb(255,255,255)",
          "rgb(255,255,255)",
          "rgb(255,255,255)"
        ]
      });
      return velocityLayer;
    },

    //经纬度转度分秒
    decimalToDMS(decimal) {
      const degrees = Math.floor(decimal);
      const minutes = Math.floor((decimal - degrees) * 60);
      const seconds = Math.floor(
        Math.round((decimal - degrees - minutes / 60) * 3600 * 1000) / 1000
      ); // 保留千分位
      return `${degrees}° ${minutes}' ${seconds}"`;
    },
    // 打开飞机搜索框
    openSearch() {
      this.searchForm.uasID = ''; // 清空搜索框
      this.searchFormVisible = true;
    },
    handleSearch() {
      console.log("搜索内容：", this.searchForm.uasID);
      if (this.infoArr.length > 0) {
        var foundObject = this.infoArr.find((item) => {
          // 根据uavSerial查找匹配飞机
          return item.uasID === this.searchForm.uasID;
        });
        if (foundObject) {
          let point = {
            longitude: foundObject.longtitude,
            latitude: foundObject.latitude
          };
          this.positionPoint(point);
        }
      }
      this.searchFormVisible = false;
    },

    // 生成随机字符串
    generateRandomString(length = 10) {
      const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return result;
    },
    // 获取地图边界
    getBounds() {
      let bounds = this.map.getBounds(); // 获取地图边界
      let southWest = bounds.getSouthWest(); // 获取边界的西南角
      let northEast = bounds.getNorthEast(); // 获取边界的东北角
      let point1 = gcj02ToWgs84(southWest.lng, southWest.lat); // 左下的点
      let point2 = gcj02ToWgs84(northEast.lng, northEast.lat); // 右上的点
      this.southWestLat = point1[1];
      this.southWestLng = point1[0];
      this.northEastLat = point2[1];
      this.northEastLng = point2[0];
    },
    // 发送边界数据
    sendBounds() {
      let data = {
        southWestLat: this.southWestLat,
        southWestLng: this.southWestLng,
        northEastLat: this.northEastLat,
        northEastLng: this.northEastLng
      };
      this.ws.send(JSON.stringify(data));
    },
    // 搜索执行中的计划
    searchItem3(val) {
      // console.log('执行中',val);
      this.searchKey3 = val;
      // this.queryPlan();
    },
    // 搜索待执行的计划
    searchItem2(val) {
      // console.log('未执行',val);
      this.searchKey2 = val;
      // this.queryPlan();
    },
    // 搜索实时事件 todo 后端没有单独接口，靠条件进行过滤的，暂不处理
    searchItem1(val) {
      // console.log('实时',val);
      this.searchKey1 = val;
      this.unExecutedPlan();
    },
  },
  destroyed() {
    if (window.queryTaskTimer) {
      clearInterval(window.queryTaskTimer);
      window.queryTaskTimer = null;
    }
    if (window.predictionTimer) {
      clearInterval(window.predictionTimer);
      window.predictionTimer = null;
    }
  },
  watch: {
    //监听orderID变动则更新航道
    oldOrderId: {
      handler(newVal, oldVal) {
        const arraysAreEqual =
          newVal.length === oldVal.length &&
          newVal.every((value, index) => value === oldVal[index]);
        if (!arraysAreEqual) {
          //此处后端有bug，需下一个接口能拿到航线数据
          // this.againPlaneWay();
          // setTimeout(() => {
          //   this.againPlaneWay();
          // }, 2000);
        }
      }
    },
    tooltipPermanent: {
      handler(newVal, oldVal) {
        this.updateTooltip = true;
      }
    },
    infoArr: {
      handler(newVal, oldVal) {
        //监听第一次获得航点数据，
        // if (oldVal.length == 0 && newVal.length > 0) {
        //   this.getCurrentStatus();
        // }
        //监听上次航点有数据，本次无数据则停止调用获取航点接口
        if (oldVal.length > 0 && newVal.length == 0) {
          clearInterval(window.queryTimer);
        }
      }
    },
    isStyleApplied: {
      handler(newVal, oldVal) {
        if(this.map){
          if(this.cityLayer){
            this.cityLayer.setStyle({
              color: this.isStyleApplied? 'rgba(214, 211, 241, 1)' : 'rgba(255, 254, 190, 1)',
              weight: 2,
              fillColor: this.isStyleApplied? 'rgba(219, 217, 255, 0.48)' : 'rgba(255, 246, 141, 0.48)',
              fillOpacity: 0.48
            });
          }
          this.airSpaces.map(v => {
            v.setStyle({
              color:
                this.isStyleApplied ? 'rgba(214,211,241,0.48)' : v.myCustomType === 0 || v.myCustomType === 1
                  ? "#e21838"
                  : v.myCustomType === 3
                    ? "#21f48e"
                    : v.myCustomType === 4 ||
                      v.myCustomType === 21
                      ? "yellow"
                      : v.myCustomType === 11
                        ? "orange"
                        : null, //填充颜色, //边框颜色#aa0000
              fillColor:
                this.isStyleApplied ? 'rgba(214,211,241,0.48)' : v.myCustomType === 0 || v.myCustomType === 1
                  ? "rgba(226,24,56,0.48)"
                  : v.myCustomType === 3
                    ? "rgba(32,180,67,0.48)"
                    : v.myCustomType === 4 ||
                      v.myCustomType === 21
                      ? "rgba(252,255,44,0.48)"
                      : v.myCustomType === 11
                        ? "rgba(248,168,34,0.48)"
                        : null, //填充颜色
              fillOpacity: 1, //填充透明度
              weight: 1 //边框宽度
            });
          })
        }
      }
    },
  },
};
</script>

<style scoped>
  @import "../../assets/css/home/FlightPlayback.scss";
</style>



// WEBPACK FOOTER //
// src/components/home/FlightPlayback.vue